import { fromJS, List } from 'immutable';
import * as _ from 'lodash';
import * as R from 'ramda';
import * as propertyActions from '../actions/property';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';
import { getRandId } from '@modules/appraisal/utils';
import { removeEmptyOptions } from '@utils';
import { WORK_ITEMS_UPDATED } from '../constants/property';

const getDropdownPath = (action, stateOrData) => [
  'dropdowns',
  stateOrData,
  ...(action.category ? [action.category] : []),
  action.fieldName,
];

const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
  state.setIn(
    [arrayName, 'data'],
    fromJS(
      state
        .getIn([arrayName, 'data'])
        .toJS()
        .map((x) =>
          x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
            ? action.data.results[0]
            : x,
        ),
    ),
  );

const initialState = {
  accountStatus: { data: { label: 'Active', value: 'Active' } },
  config: { data: [], state: null },
  applicationEvents: { data: [], totalEvents: 0, state: null },
  buildingPermit: { data: {}, state: null },
  buildingPermitFiles: {},
  buildingPermitProperties: { data: [], state: null },
  buildingPermits: { data: [], state: null },
  buildingPermitCodefiles: {
    issuerCodes: { data: [], state: null },
    types: { data: [], state: null },
    subTypes: { data: [], state: null },
    status: { data: [], state: null },
    CADStatus: { data: [], state: null },
    propertyCategories: { data: [], state: null },
  },
  codeFilePropertyTags: { data: [], state: null },
  codeFilePropertyTagsByYear: {},
  currentImprovements: {
    data: { ownerSitus: [], improvements: [] },
    state: null,
  },
  currentLands: {
    data: { ownerSitus: [], lands: [] },
    state: null,
  },
  renderedValue: { data: [], state: null },
  propertyTags: { data: [], state: null },
  primaryImageUrl: { data: {}, state: null },
  eventTypes: [],
  eventForms: [],
  rollHistory: { data: [], state: null },
  appraisalNoticeHistory: { data: [], state: null },
  resultsConfig: { data: [], state: null },
  searchLastPayload: { data: {}, state: null },
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
    isHistorySearch: false,
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 1000,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  sketchLink: {
    results: {
      state: null,
      data: [],
    },
    currentLink: {
      state: null,
      data: [],
    },
  },
  propertyMenuList: {},
  subpage: {},
  property: {},
  propertyFull: {},
  propertyFullMass: { data: [], state: null },
  propertyAppraisers: {},
  propertyPrimaryAppraiser: {},
  propertySmartGroups: {},
  propertyValueReady: { data: [], state: null },
  smartGroup: {},
  smartGroupProperties: {},
  smartGroupTypes: {},
  smartGroupsBySearch: {},
  summary: {},
  ownerSummary: {},
  inspections: {},
  inspection: {},
  reasonCodes: {},
  notes: {},
  recalculate: { data: {}, state: null },
  valuationWidgetState: {},
  events: { data: [], state: null, eventSearchValue: '' },
  propertyLookupModal: {
    open: false,
    mode: null,
    futureYear: false,
    marketLookup: false,
    currentValuation: null,
    searchParams: [],
    primarySearchFields: [],
    primaryResultFields: [],
    state: '',
    data: [],
    selection: [],
    count: 0,
  },
  autoCompleteLegal: { state: '', data: {} },
  autoCompleteMineralLegal: { state: '', data: {} },
  singleCreate: { state: '', data: [] },
  massCreate: { state: '', data: [] },
  createMassCreate: { state: '', data: [] },
  massCreatePrepData: { state: '', data: [] },
  massCreateSettings: { state: '', data: [] },
  massCreateSettingsAvailPropTypes: { state: '', data: [] },
  walkthroughSettings: { state: '', data: [] },
  plats: { state: '', data: [] },
  mergeProperties: [],
  mergedProperty: {},
  applications: {
    data: [],
    codefiles: {
      type: [],
      status: [],
      owners: [],
      idType: [],
    },
    state: null,
  },
  pExemptions: {
    data: [],
    state: null,
  },
  improvementTypes: {
    data: [],
    state: null,
  },
  exemptions: {
    data: [],
    codefiles: {
      codes: [],
      years: [],
    },
    rollCorrectionCodes: {
      data: {},
      state: null,
    },
    propertyList: {
      data: [],
      state: null,
    },
    state: null,
  },
  exemptionNotes: {
    data: [],
    state: null,
  },
  select: {
    type: null,
    open: false,
    addresses: [],
  },
  pExemption: {
    codeInfo: {},
    data: {},
    state: null,
  },
  owners: {
    data: null,
    state: null,
  },
  taxOfficeIdentifier: {
    data: null,
    state: null,
  },
  allExemptions: {
    data: [],
    state: null,
  },
  allTaxingUnits: {
    data: [],
    state: null,
  },
  hsDetails: {
    data: {},
    state: null,
  },
  ownerNames: { data: [], state: null },
  taxables: {
    data: [],
    totalTaxes: '',
    totalRate: '',
    state: null,
  },
  taxableDetails: { data: {}, state: null },
  summaryBPP: { data: null, state: null },
  valuations: { data: [], state: null },
  valuationsBpp: { data: [], state: null },
  taxingunitsplitboundarylines: {
    data: {
      taxingUnitSplitBoundaryLines: false,
      taxingUnitPercentCalculation: 'T',
    },
    state: null,
  },
  taxingunitsegments: { data: [], state: null },
  taxingunitsegment: { data: [], state: null },
  lastAppraisal: { data: {}, state: null },
  files: { data: [], state: null },
  inspectionFiles: {},
  propertyLinks: { data: [], state: null },
  recalculationJob: { data: {}, state: null },
  openRollCorrections: { data: [], state: null },
  propertyRollCorrection: { data: {} },
  printCard: { data: null, state: null },
  janOneOwner: { data: [], state: null },
  calculationRules: { data: [], state: null },
  allocationFactors: { data: [], state: null },
  taxingUnitLookup: { data: {}, state: null },
  propertyForSit: { data: {}, state: null },
  sitDetails: { data: [], state: null },
  sit: { data: {}, state: null },
  sitDetail: { data: {}, state: null },
  sitDetailFiles: { data: [], state: null },
  bppImport: { data: [], state: null },
  bppImportErrors: { data: [], state: null },
  marketApproach: { data: {}, state: null, error: {} },
  marketApproachCompImages: { data: [], state: null },
  marketApproachSubject: { data: {}, state: null },
  equityApproachSubject: { data: {}, state: null },
  marketApproachTiers: { data: [], state: null },
  equityApproachTiers: { data: [], state: null },
  marketApproachManualSelection: { data: [], state: null },
  equityApproachManualSelection: { data: [], state: null },
  equityApproach: { data: {}, state: null, error: {} },
  equityApproachCompImages: { data: [], state: null },
  appeals: { data: [], state: null },
  efile: { data: {}, state: null },
  currentPropertyIsEditable: false,
  equityResults: { data: [], state: null },
  errors: { data: [], state: null },
  backProperty: {},
  propertyEventBackOption: {},
  groupOpenRollCorrections: { data: [], state: null },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  propertySearchFormData: {},
  appraisalCompanies: { data: [], state: null },
  appraisalCompanyLastImport: {},
  workItems: { data: [], state: null },
  lateRenditionPenalty: {
    data: null,
    state: null,
  },
  propertyCases: { data: [], state: null },
  bppSubDetails: { data: [], state: null },
  selectedPersonalDetailID: null,
  dashboardBreadcrumb: false,
  tirz: {},
  tirzTaxingUnits: { data: [], state: null },
  bppDetailFileList: { data: [], state: null },
  fileBppDetail: {},
  ptdSummary: {
    stateCodes: {
      data: [],
      state: null,
    },
    ag: {
      data: [],
      state: null,
    },
  },
  openRollCorrectionGroups: { data: [], state: null },
  imageGalleryOptions: { data: {}, state: null },
  imageGalleryData: { data: {}, state: null },
  recalculateTrigger: false,
  taxDeferral: { data: {}, state: null },
  futureVersion: {
    canCreateFutureVersion: false,
    canCreateErrorReason: '',
    hasFutureVersion: false,
    pID: null,
    pRollCorr: null,
    pVersion: null,
    pYear: null,
  },
  publicPortalAssociatedUsers: { data: [], state: null },
  propertyEfile: {
    eFile: { data: {}, state: null },
    associatedUsers: { data: [], state: null },
    eFileHistory: { data: [], state: null },
  },
  timber78Values: {
    data: [],
    state: null,
  },
  impDetailManagerCharacteristics: { data: [], state: null },
  impDetailManagerConditions: { data: [], state: null },
  impDetailManagerNewValue: { data: {}, state: null },
  impDetailManagerPricingModel: { data: [], state: null },
  impDetailManagerAdjustment: { data: [], state: null },
  propertiesMassUpdateMultiYear: [],
  propertyElectronicRequests: { data: [], state: null },
  workItemsUpdated: null,
};

export const sortByGroupAndOrder = (a, b) =>
  a.group * 10 + a.order - (b.group * 10 + b.order);

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case propertyActions.SET_RECALCULATE_TRIGGER:
      return state.setIn(['recalculateTrigger'], action.data);
    case propertyActions.PROPERTY_TAX_DEFERRAL_FETCH[SUCCESS]: {
      return state
        .setIn(['taxDeferral', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxDeferral', 'data'],
          fromJS(action.data.results ? action.data.results[0] : []),
        );
    }
    case propertyActions.PROPERTY_TAX_DEFERRAL_FETCH[START]: {
      return state.setIn(['taxDeferral', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_TAX_DEFERRAL_FETCH[ERROR]: {
      return state.setIn(['taxDeferral', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_TAX_DEFERRAL_UPDATE[SUCCESS]: {
      return state
        .setIn(['taxDeferral', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxDeferral', 'data'],
          fromJS(action.data.results ? action.data.results[0] : []),
        );
    }
    case propertyActions.PROPERTY_TAX_DEFERRAL_UPDATE[START]: {
      return state.setIn(['taxDeferral', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_TAX_DEFERRAL_UPDATE[ERROR]: {
      return state.setIn(['taxDeferral', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_FETCH_RENDERED_VALUE[SUCCESS]: {
      return state
        .setIn(['renderedValue', 'state'], fetchingState.LOADED)
        .setIn(['renderedValue', 'data'], fromJS(action.data.results));
    }
    case propertyActions.PROPERTY_FETCH_RENDERED_VALUE[START]: {
      return state.setIn(['renderedValue', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_RENDERED_VALUE[ERROR]: {
      return state.setIn(['renderedValue', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_UPDATE_RENDERED_VALUE[SUCCESS]: {
      return state
        .setIn(['renderedValue', 'state'], fetchingState.LOADED)
        .setIn(['renderedValue', 'data'], fromJS(action.data.results));
    }
    case propertyActions.PROPERTY_UPDATE_RENDERED_VALUE[START]: {
      return state.setIn(['renderedValue', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_UPDATE_RENDERED_VALUE[ERROR]: {
      return state.setIn(['renderedValue', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_VALUE_LOCK_STATUS_UPDATE[SUCCESS]: {
      return state.setIn(
        ['property', 'data', 'valueLocked'],
        fromJS(action.data ? action.data.results[0].valueLocked : null),
      );
    }
    case propertyActions.FETCH_PERSONAL_DETAIL_FILES[START]: {
      return state.setIn(
        ['bppDetailFileList', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_PERSONAL_DETAIL_FILES[SUCCESS]: {
      return state
        .setIn(['bppDetailFileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['bppDetailFileList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachment', [])),
        )
        .setIn(['fileBppDetail'], fromJS(_.get(action, 'data.results[0]', [])));
    }
    case propertyActions.FETCH_PERSONAL_DETAIL_FILES[ERROR]: {
      return state.setIn(['bppDetailFileList', 'state'], fetchingState.ERROR);
    }
    case propertyActions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state.setIn(['config', 'state'], fetchingState.LOADED).setIn(
        ['config', 'data'],
        fromJS(
          action.data.results
            .map((field) => ({
              ...field,
              code: field.code || null,
            }))
            .sort(sortByGroupAndOrder),
        ),
      );
    }
    case propertyActions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case propertyActions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_SEARCH_START: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['results', 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize)
        .setIn(['results', 'isHistorySearch'], action.isHistorySearch);
    }
    case propertyActions.PROPERTY_SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['searchLastPayload', 'data'],
          fromJS(_.get(action, 'payload', {})),
        )
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalProperty.propertyCount', 0),
        );
    }
    case propertyActions.PROPERTY_SEARCH_ERROR: {
      return state
        .setIn(['results', 'state'], fetchingState.ERROR)
        .setIn(['results', 'isHistorySearch'], false);
    }

    case propertyActions.FETCH_PROPERTY_VALUE_READY[START]: {
      return state.setIn(
        ['propertyValueReady', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_PROPERTY_VALUE_READY[SUCCESS]: {
      return state
        .setIn(['propertyValueReady', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyValueReady', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.FETCH_PROPERTY_VALUE_READY[ERROR]: {
      return state.setIn(['propertyValueReady', 'state'], fetchingState.ERROR);
    }

    case propertyActions.UPDATE_PROPERTY_VALUE_READY[START]: {
      return state.setIn(
        ['propertyValueReady', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.UPDATE_PROPERTY_VALUE_READY[SUCCESS]: {
      return state
        .setIn(['propertyValueReady', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyValueReady', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.UPDATE_PROPERTY_VALUE_READY[ERROR]: {
      return state.setIn(['propertyValueReady', 'state'], fetchingState.ERROR);
    }

    case propertyActions.UPDATE_PROPERTY_SPECIAL_USE_RESET[SUCCESS]: {
      return state
        .setIn(
          ['property', 'data', 'suReset'],
          fromJS(
            action.data && action.data.results && action.data.results[0]
              ? action.data.results[0].suReset
              : null,
          ),
        )
        .setIn(
          ['property', 'data', 'updateDt'],
          fromJS(
            action.data && action.data.results && action.data.results[0]
              ? action.data.results[0].updateDt
              : null,
          ),
        );
    }

    case propertyActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case propertyActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case propertyActions.CHANGE_SORT_MODEL: {
      return state.setIn(['results', 'sortModel'], fromJS(action.payload));
    }
    case propertyActions.CHANGE_FILTER_MODEL: {
      return state.setIn(['results', 'filterModel'], fromJS(action.payload));
    }

    case propertyActions.PROPERTY_FULL_FETCH_START:
      return state.setIn(['propertyFull', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FULL_FETCH_SUCCESS:
      let tempState = state.setIn(
        ['propertyFull', 'state'],
        fetchingState.LOADED,
      );
      return tempState.setIn(
        ['propertyFull', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FULL_FETCH_ERROR:
      return state.setIn(['propertyFull', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FULL_MASS_FETCH_START:
      return state.setIn(['propertyFullMass', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FULL_MASS_FETCH_SUCCESS:
      let fullMassState = state.setIn(
        ['propertyFullMass', 'state'],
        fetchingState.LOADED,
      );
      return fullMassState.setIn(
        ['propertyFullMass', 'data'],
        fromJS(action.data ? action.data : null),
      );
    case propertyActions.PROPERTY_FULL_MASS_FETCH_ERROR:
      return state.setIn(['propertyFullMass', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_START:
      return state.setIn(['property', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_SUCCESS:
      let newState = state.setIn(['property', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['property', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_ERROR:
      return state.setIn(['property', 'state'], fetchingState.ERROR);
    case propertyActions.SKETCH_SEARCH_SUCCESS: {
      return state
        .setIn(['sketchLink', 'results', 'state'], fetchingState.LOADED)
        .setIn(
          ['sketchLink', 'results', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case propertyActions.PROPERTY_FETCH_STATUS[SUCCESS]:
      return state.setIn(
        ['property', 'data'],
        fromJS({
          ...state.getIn(['property', 'data'], List([])).toJS(),
          ..._.get(action, 'data.results[0]', {}),
        }),
      );

    case propertyActions.PROPERTY_FETCH_EDITABLE_STATUS[SUCCESS]:
      return state.set(
        'currentPropertyIsEditable',
        _.get(action, 'data.results.isEditable', {}),
      );

    case propertyActions.SKETCH_SEARCH_START: {
      return state.setIn(
        ['sketchLink', 'results', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.SKETCH_SEARCH_ERROR: {
      return state.setIn(
        ['sketchLink', 'results', 'state'],
        fetchingState.ERROR,
      );
    }
    case propertyActions.LINK_SKETCH_SUCCESS: {
      return state
        .setIn(['sketchLink', 'currentLink', 'state'], fetchingState.LOADED)
        .setIn(
          ['sketchLink', 'currentLink', 'data'],
          fromJS(_.get(action, 'data.results')),
        );
    }
    case propertyActions.LINK_SKETCH_START: {
      return state.setIn(
        ['sketchLink', 'currentLink', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.LINK_SKETCH_ERROR: {
      return state.setIn(
        ['sketchLink', 'currentLink', 'state'],
        fetchingState.ERROR,
      );
    }
    case propertyActions.PROPERTY_NOTES_FETCH_START:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_NOTES_FETCH_SUCCESS:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_NOTES_FETCH_ERROR:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_START:
      return state.setIn(['property', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_UPDATE_ERROR:
      return state.setIn(['property', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_SUCCESS:
      newState = state.setIn(['property', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['property', 'data'],
        fromJS(action.data.results[0]),
      );
    case propertyActions.PROPERTY_UPDATE_PRIMARY_IMAGE_START:
      return state.setIn(['primaryImageUrl', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_UPDATE_PRIMARY_IMAGE_ERROR:
      return state.setIn(['primaryImageUrl', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_PRIMARY_IMAGE_SUCCESS:
      newState = state.setIn(
        ['primaryImageUrl', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['primaryImageUrl', 'data'],
        fromJS(action.data && action.data.results),
      );
    case propertyActions.PROPERTY_RESET_DATA:
      return state.setIn(['property'], fromJS({}));
    case propertyActions.PROPERTY_CREATE[START]:
      return state.setIn(['property', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_CREATE[SUCCESS]:
      newState = state.setIn(['property', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['property', 'data'],
        fromJS(action.data.results[0]),
      );
    case propertyActions.PROPERTY_CREATE[ERROR]:
      return state.setIn(['property', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_VALIDATE_SUCCESS:
      return state.setIn(['property', 'data'], fromJS(action.data.results[0]));

    case propertyActions.PROPERTY_NOTE_ADD_SUCCESS:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case propertyActions.PROPERTY_NOTE_DELETE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter((n) => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case propertyActions.PROPERTY_NOTE_UPDATE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter((n) => n.noteID !== action.noteId);
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case propertyActions.PROPERTY_FETCH_MENU_PROFILES[START]:
      return state.setIn(['propertyMenuList', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_MENU_PROFILES[SUCCESS]:
      newState = state.setIn(
        ['propertyMenuList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyMenuList', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_MENU_PROFILES[ERROR]:
      return state.setIn(['propertyMenuList', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_SUB_PAGE[START]:
      newState = state.setIn(['subpage', 'data'], fromJS(null));
      return newState.setIn(['subpage', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_SUB_PAGE[SUCCESS]:
      newState = state.setIn(['subpage', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['subpage', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_SUB_PAGE[ERROR]:
      return state.setIn(['subpage', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_HEADER[START]:
      newState = state.setIn(['header', 'data'], fromJS(null));
      return newState.setIn(['header', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_HEADER[SUCCESS]:
      newState = state.setIn(['header', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['header', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_HEADER[ERROR]:
      return state.setIn(['header', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_SUMMARY[START]:
      newState = state.setIn(['summary', 'data'], fromJS(null));
      return newState.setIn(['summary', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_SUMMARY[SUCCESS]:
      newState = state.setIn(['summary', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['summary', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_SUMMARY[ERROR]:
      return state.setIn(['summary', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_OWNER_SUMMARY[START]:
      newState = state.setIn(['ownerSummary', 'data'], fromJS(null));
      return newState.setIn(['ownerSummary', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_OWNER_SUMMARY[SUCCESS]:
      newState = state.setIn(['ownerSummary', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['ownerSummary', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_OWNER_SUMMARY[ERROR]:
      return state.setIn(['ownerSummary', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CLEAR_SUMMARY:
      return state.setIn(['summary'], fromJS({}));

    case propertyActions.PROPERTY_FETCH_MOBILE_HOMES[START]:
      newState = state.setIn(['mobileHomes', 'data'], fromJS(null));
      return newState.setIn(['mobileHomes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_MOBILE_HOMES[SUCCESS]:
      newState = state.setIn(['mobileHomes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['mobileHomes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_MOBILE_HOMES[ERROR]:
      return state.setIn(['mobileHomes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_LEGAL_DESCRIPTION[START]:
      newState = state.setIn(['legalDescription', 'data'], fromJS(null));
      return newState.setIn(
        ['legalDescription', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_LEGAL_DESCRIPTION[SUCCESS]:
      newState = state.setIn(
        ['legalDescription', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['legalDescription', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_LEGAL_DESCRIPTION[ERROR]:
      return state.setIn(['legalDescription', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_LEGAL_DESCRIPTION[START]:
      return state.setIn(['legalDescription', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_UPDATE_LEGAL_DESCRIPTION[ERROR]:
      return state.setIn(['legalDescription', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_LEGAL_DESCRIPTION[SUCCESS]:
      newState = state.setIn(
        ['legalDescription', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['legalDescription', 'data'],
        fromJS(action.data.results[0]),
      );

    case propertyActions.PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[START]:
      newState = state.setIn(['mineralLegalDescription', 'data'], fromJS(null));
      return newState.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[SUCCESS]:
      newState = state.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['mineralLegalDescription', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[ERROR]:
      return state.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[START]:
      return state.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.SAVING,
      );
    case propertyActions.PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[ERROR]:
      return state.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[SUCCESS]:
      newState = state.setIn(
        ['mineralLegalDescription', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['mineralLegalDescription', 'data'],
        fromJS(action.data.results[0]),
      );

    case propertyActions.FETCH_AUTO_COMPLETE_MINERAL_LEGAL[START]: {
      return state
        .setIn(['autoCompleteMineralLegal', 'data'], fromJS({}))
        .setIn(['autoCompleteMineralLegal', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_AUTO_COMPLETE_MINERAL_LEGAL[SUCCESS]: {
      return state
        .setIn(['autoCompleteMineralLegal', 'state'], fetchingState.LOADED)
        .setIn(
          ['autoCompleteMineralLegal', 'data'],
          fromJS(_.get(action, 'data.results', {})),
        );
    }
    case propertyActions.FETCH_AUTO_COMPLETE_MINERAL_LEGAL[ERROR]: {
      return state
        .setIn(['autoCompleteMineralLegal', 'data'], fromJS({}))
        .setIn(['autoCompleteMineralLegal', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_IDENTIFICATION[START]:
      newState = state.setIn(['identification', 'data'], fromJS(null));
      return newState.setIn(
        ['identification', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IDENTIFICATION[SUCCESS]:
      newState = state.setIn(['identification', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['identification', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_IDENTIFICATION[ERROR]:
      return state.setIn(['identification', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_IDENTIFICATION[START]:
      return state.setIn(['identification', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_UPDATE_IDENTIFICATION[ERROR]:
      return state.setIn(['identification', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_IDENTIFICATION[SUCCESS]:
      newState = state.setIn(['identification', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['identification', 'data'],
        fromJS(action.data.results[0]),
      );

    case propertyActions.PROPERTY_FETCH_CHARACTERISTICS[START]:
      newState = state.setIn(['characteristics', 'data'], fromJS(null));
      return newState.setIn(
        ['characteristics', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_CHARACTERISTICS[SUCCESS]:
      newState = state.setIn(
        ['characteristics', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['characteristics', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_CHARACTERISTICS[ERROR]:
      return state.setIn(['characteristics', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_CHARACTERISTICS[START]:
      return state.setIn(['characteristics', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_UPDATE_CHARACTERISTICS[ERROR]:
      return state.setIn(['characteristics', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_CHARACTERISTICS[SUCCESS]:
      newState = state.setIn(
        ['characteristics', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['characteristics', 'data'],
        fromJS(action.data.results[0]),
      );

    case propertyActions.PROPERTY_FETCH_DROPDOWNS[START]:
      return state.setIn(
        getDropdownPath(action, 'state'),
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_DROPDOWNS[SUCCESS]:
      if (action && action.fieldName === 'tags') {
        let newData = [];
        for (let x = 0; x < action.data.results.length; x++) {
          let duplicate = false;
          for (let y = 0; y < newData.length; y++) {
            if (action.data.results[x].codeName === newData[y].codeName) {
              duplicate = true;
              y = newData.length;
            }
          }
          if (!duplicate) {
            newData.push(action.data.results[x]);
          }
        }
        action.data.results = newData;
      }
      if (
        action &&
        action.fieldName === 'valueType' &&
        action.data.results &&
        action.data.results.length
      ) {
        action.data.results = action.data.results.map((r) => {
          return {
            codeName: r,
            codeDescription: r,
          };
        });
      }
      newState = state.setIn(
        getDropdownPath(action, 'state'),
        fetchingState.LOADED,
      );
      return newState.setIn(
        getDropdownPath(action, 'data'),
        fromJS(action.data ? action.data.results || action.data : []),
      );
    case propertyActions.PROPERTY_FETCH_DROPDOWNS[ERROR]:
      return state.setIn(getDropdownPath(action, 'state'), fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_TAXING_UNITS[START]:
      newState = state.setIn(['taxingUnits', 'data'], fromJS(null));
      return newState.setIn(['taxingUnits', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_TAXING_UNITS[SUCCESS]:
      newState = state.setIn(['taxingUnits', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['taxingUnits', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_TAXING_UNITS[ERROR]:
      return state.setIn(['taxingUnits', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_ALL_TAXING_UNITS[START]:
      return state
        .setIn(['allTaxingUnits', 'data'], fromJS([]))
        .setIn(['allTaxingUnits', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_ALL_TAXING_UNITS[SUCCESS]:
      return state
        .setIn(['allTaxingUnits', 'state'], fetchingState.LOADED)
        .setIn(
          ['allTaxingUnits', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    case propertyActions.PROPERTY_FETCH_ALL_TAXING_UNITS[ERROR]:
      return state.setIn(['allTaxingUnits', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_ADD_DUMMY_TAXING_UNIT[SUCCESS]:
      const list = state.getIn(['allTaxingUnits', 'data']).toJS();

      return state.setIn(
        ['allTaxingUnits', 'data'],
        fromJS(list.concat([action.payload])),
      );

    case propertyActions.PROPERTY_CREATE_TAXING_UNIT[SUCCESS]:
      return state.setIn(
        ['allTaxingUnits', 'data'],
        fromJS(
          state
            .getIn(['allTaxingUnits', 'data'])
            .toJS()
            .concat(action.data.results),
        ),
      );

    case propertyActions.PROPERTY_DELETE_TAXING_UNIT[SUCCESS]:
      return state.setIn(
        ['allTaxingUnits', 'data'],
        fromJS(
          state
            .getIn(['allTaxingUnits', 'data'])
            .toJS()
            .filter((t) => t.pTaxingUnitID !== action.taxingUnitId),
        ),
      );

    case propertyActions.PROPERTY_UPDATE_TAXING_UNIT[SUCCESS]:
      return state.setIn(
        ['allTaxingUnits', 'data'],
        fromJS(
          state
            .getIn(['allTaxingUnits', 'data'])
            .toJS()
            .map((t) => {
              if (t.pTaxingUnitID === action.taxingUnitId) {
                return {
                  ...t,
                  ...action.data.results[0],
                };
              }
              return t;
            }),
        ),
      );

    case propertyActions.PROPERTY_FETCH_PRIMARY_OWNER[START]:
      newState = state.setIn(['primaryOwner', 'data'], fromJS(null));
      return newState.setIn(['primaryOwner', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_PRIMARY_OWNER[SUCCESS]:
      newState = state.setIn(['primaryOwner', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['primaryOwner', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_PRIMARY_OWNER[ERROR]:
      return state.setIn(['primaryOwner', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_PRIMARY_SITUS[START]:
      newState = state.setIn(['primarySitus', 'data'], fromJS(null));
      return newState.setIn(['primarySitus', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_PRIMARY_SITUS[SUCCESS]:
      newState = state.setIn(['primarySitus', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['primarySitus', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_PRIMARY_SITUS[ERROR]:
      return state.setIn(['primarySitus', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_ALL_SITUS[START]:
      newState = state.setIn(['allSitus', 'data'], fromJS(null));
      return newState.setIn(['allSitus', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_ALL_SITUS[SUCCESS]:
      newState = state.setIn(['allSitus', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['allSitus', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_ALL_SITUS[ERROR]:
      return state.setIn(['allSitus', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_SITUS[SUCCESS]:
      let newSitus = state.getIn(['allSitus', 'data']).toJS();
      newSitus = newSitus.concat(action.data.results);
      return state.setIn(['allSitus', 'data'], fromJS(newSitus));

    case propertyActions.PROPERTY_DELETE_SITUS[SUCCESS]:
      newSitus = state.getIn(['allSitus', 'data']).toJS();
      newSitus = newSitus.filter((s) => s.situsAddressID !== action.situsId);
      return state.setIn(['allSitus', 'data'], fromJS(newSitus));

    case propertyActions.PROPERTY_UPDATE_SITUS[SUCCESS]:
      newSitus = state.getIn(['allSitus', 'data']).toJS();
      newSitus = newSitus.filter((n) => n.situsAddressID !== action.situsId);
      newSitus = newSitus.concat(action.data.results);
      return state.setIn(['allSitus', 'data'], fromJS(newSitus));

    case propertyActions.PROPERTY_SET_PRIMARY_SITUS[SUCCESS]:
      newState = state.setIn(['allSitus', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['allSitus', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    case propertyActions.PROPERTY_FETCH_VALUATION_TYPES[START]:
      newState = state.setIn(['valuationTypes', 'data'], fromJS([]));
      return state.setIn(['valuationTypes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_VALUATION_TYPES[SUCCESS]:
      newState = state.setIn(['valuationTypes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['valuationTypes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_VALUATION_TYPES[ERROR]:
      return state.setIn(['valuationTypes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_TYPES[START]:
      newState = state.setIn(['improvementTypes', 'data'], fromJS([]));
      return state.setIn(['improvementTypes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_TYPES[SUCCESS]:
      newState = state.setIn(
        ['improvementTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementTypes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_TYPES[ERROR]:
      return state.setIn(['improvementTypes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_SET_VALUATION_WIDGET_STATE:
      return state.setIn(
        ['valuationWidgetState'],
        fromJS({
          ...state.getIn(['valuationWidgetState']).toJS(),
          ...action.payload,
        }),
      );

    case propertyActions.PROPERTY_FETCH_VALUATIONS[START]:
      newState = state.setIn(['valuations', 'data'], fromJS([]));
      return newState.setIn(['valuations', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_VALUATIONS[SUCCESS]:
      newState = state.setIn(['valuations', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['valuations', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_VALUATIONS[ERROR]:
      return state.setIn(['valuations', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_VALUATION[SUCCESS]:
      let newValuations =
        (state.getIn(['valuations', 'data']) &&
          state.getIn(['valuations', 'data']).toJS()) ||
        [];
      newValuations = newValuations.concat(action.data.results);
      return state.setIn(['valuations', 'data'], fromJS(newValuations));

    case propertyActions.PROPERTY_UPDATE_VALUATION[SUCCESS]:
      return state.setIn(
        ['valuations', 'data'],
        fromJS(
          state
            .getIn(['valuations', 'data'])
            .toJS()
            .map((x) =>
              x.pValuationID !== action.data.results[0].pValuationID
                ? x
                : action.data.results[0],
            ),
        ),
      );

    case propertyActions.PROPERTY_SET_PRIMARY_VALUATION[SUCCESS]:
      newState = state.setIn(
        ['valuations', 'data'],
        fromJS(
          state
            .getIn(['valuations', 'data'], [])
            .toJS()
            .map((x) =>
              x.pValuationID !== action.data.results[0].pValuationID
                ? { ...x, isPrimary: 0 }
                : { ...x, ...action.data.results[0] },
            ),
        ),
      );
      return newState.setIn(
        ['valuationsBpp', 'data'],
        fromJS(
          state
            .getIn(['valuationsBpp', 'data'], [])
            .toJS()
            .map((x) =>
              x.pValuationID !== action.data.results[0].pValuationID
                ? { ...x, isPrimary: 0 }
                : { ...x, isPrimary: 1 },
            ),
        ),
      );

    case propertyActions.PROPERTY_DELETE_VALUATION[SUCCESS]:
      newValuations = state.getIn(['valuations', 'data']).toJS();
      newValuations = newValuations.filter(
        (v) => v.pValuationID !== action.valuationId,
      );
      newValuationsBpp = state.getIn(['valuationsBpp', 'data']);
      newValuationsBpp = newValuationsBpp ? newValuationsBpp.toJS() : [];
      newValuationsBpp = newValuationsBpp.filter(
        (v) => v.pValuationID !== action.valuationId,
      );
      newState = state.setIn(['valuations', 'data'], fromJS(newValuations));
      return newState.setIn(
        ['valuationsBpp', 'data'],
        fromJS(newValuationsBpp),
      );
    // IMPROVEMENT
    case propertyActions.PROPERTY_FETCH_IMPROVEMENTS[START]:
      newState = state.setIn(['improvements', 'data'], fromJS([]));
      return newState.setIn(['improvements', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_IMPROVEMENTS[SUCCESS]:
      newState = state.setIn(['improvements', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['improvements', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENTS[ERROR]:
      return state.setIn(['improvements', 'state'], fetchingState.ERROR);
    case propertyActions.IMPROVEMENT_DUPLICATE[START]:
      return state.setIn(['improvements', 'loadingAction'], 'duplicate');
    case propertyActions.IMPROVEMENT_DUPLICATE[ERROR]:
      return state.setIn(['improvements', 'loadingAction'], '');
    case propertyActions.IMPROVEMENT_DUPLICATE[SUCCESS]:
      let newImprovements = state.getIn(['improvements', 'data']).toJS();
      newImprovements = [...newImprovements, action.data.results[0]];
      newState = state.setIn(['improvements', 'loadingAction'], '');
      return newState.setIn(['improvements', 'data'], fromJS(newImprovements));

    case propertyActions.PROPERTY_CREATE_IMPROVEMENT[SUCCESS]:
      let newImprovement = state.getIn(['improvements', 'data']).toJS();
      newImprovement = newImprovement.concat(action.data.results);
      newState = state.setIn(
        ['newImprovementId'],
        action.data.results[0].pImprovementID,
      );
      return newState.setIn(['improvements', 'data'], fromJS(newImprovement));

    case propertyActions.PROPERTY_UPDATE_IMPROVEMENT[SUCCESS]:
      newImprovement = state.getIn(['improvements', 'data']).toJS();
      if (action.data.results && action.data.results[0]) {
        newImprovement = newImprovement.map((r) => {
          if (r.pImprovementID === action.improvementId) {
            return action.data.results[0];
          }
          return r;
        });
      }
      return state.setIn(['improvements', 'data'], fromJS(newImprovement));

    case propertyActions.PROPERTY_DELETE_IMPROVEMENT[SUCCESS]:
      newImprovement = state.getIn(['improvements', 'data']).toJS();
      newImprovement = newImprovement.filter(
        (n) => n.pImprovementID !== action.improvementId,
      );
      return state.setIn(['improvements', 'data'], fromJS(newImprovement));

    // IMPROVEMENT DETAILS
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAILS[START]:
      if (!action.pDetailID) {
        newState = state.setIn(['improvementDetails', 'data'], fromJS([]));
        return newState.setIn(
          ['improvementDetails', 'state'],
          fetchingState.FETCHING,
        );
      }
      return state;
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAILS[SUCCESS]:
      if (action.pDetailID) {
        newState = state.getIn(['improvementDetails', 'data']).toJS();
        newState[
          action.data.results.findIndex((r) => r.pDetailID === action.pDetailID)
        ] = action.data.results.find((r) => r.pDetailID === action.pDetailID);
        return state.setIn(['improvementDetails', 'data'], fromJS(newState));
      }
      newState = state.setIn(
        ['improvementDetails', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementDetails', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAILS[ERROR]:
      return state.setIn(['improvementDetails', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_IMPROVEMENT_DETAIL[SUCCESS]:
      let newImprovementDetails =
        (state.getIn(['improvementDetails', 'data']) &&
          state.getIn(['improvementDetails', 'data']).toJS()) ||
        [];
      newImprovementDetails = newImprovementDetails.concat(action.data.results);
      return state.setIn(
        ['improvementDetails', 'data'],
        fromJS(newImprovementDetails),
      );

    case propertyActions.PROPERTY_UPDATE_IMPROVEMENT_DETAIL[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'improvementDetails',
        'pDetailID',
      );

    case propertyActions.PROPERTY_DELETE_IMPROVEMENT_DETAIL[SUCCESS]:
      newState = state.getIn(['improvementDetails', 'data']).toJS();
      newState = newState.filter(
        (n) => n.pDetailID !== action.improvementDetailId,
      );
      return state.setIn(['improvementDetails', 'data'], fromJS(newState));

    case propertyActions.IMPROVEMENT_DETAIL_DUPLICATE[START]:
      return state.setIn(['improvementDetails', 'loadingAction'], 'duplicate');
    case propertyActions.IMPROVEMENT_DETAIL_DUPLICATE[ERROR]:
      return state.setIn(['improvementDetails', 'loadingAction'], '');
    case propertyActions.IMPROVEMENT_DETAIL_DUPLICATE[SUCCESS]:
      let newImprovementDet = state
        .getIn(['improvementDetails', 'data'])
        .toJS();
      newImprovementDet = [...newImprovementDet, action.data.results[0]];
      newState = state.setIn(['improvementDetails', 'loadingAction'], '');
      return newState.setIn(
        ['improvementDetails', 'data'],
        fromJS(newImprovementDet),
      );

    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[START]:
      newState = state.setIn(['improvementDetailFeatures', 'data'], fromJS([]));
      return newState.setIn(
        ['improvementDetailFeatures', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[SUCCESS]:
      newState = state.setIn(
        ['improvementDetailFeatures', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementDetailFeatures', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[ERROR]:
      return state.setIn(
        ['improvementDetailFeatures', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES[SUCCESS]:
      newState = state.setIn(
        ['improvementDetailFeatures', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementDetailFeatures', 'data'],
        fromJS(action.data ? action.data.results : []),
      );

    // LAND
    case propertyActions.PROPERTY_FETCH_LAND[START]:
      newState = state.setIn(['land', 'data'], fromJS([]));
      return newState.setIn(['land', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_LAND[SUCCESS]:
      newState = state.setIn(['land', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['land', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_LAND[ERROR]:
      return state.setIn(['land', 'state'], fetchingState.ERROR);

    case propertyActions.LAND_DUPLICATE[START]:
      return state.setIn(['land', 'loadingAction'], 'duplicate');
    case propertyActions.LAND_DUPLICATE[ERROR]:
      return state.setIn(['land', 'loadingAction'], '');
    case propertyActions.LAND_DUPLICATE[SUCCESS]:
      let land = state.getIn(['land', 'data']).toJS();
      land = [...land, action.data.results[0]];
      newState = state.setIn(['land', 'loadingAction'], '');
      return newState.setIn(['land', 'data'], fromJS(land));

    case propertyActions.PROPERTY_CREATE_LAND[SUCCESS]:
      let newLand = state.getIn(['land', 'data']).toJS();
      newLand = newLand.concat(action.data.results);
      newState = state.setIn(['newLandId'], action.data.results[0].pLandID);
      return newState.setIn(['land', 'data'], fromJS(newLand));

    case propertyActions.PROPERTY_UPDATE_LAND[SUCCESS]:
      newLand = state.getIn(['land', 'data']).toJS();
      newLand = newLand.map((n) => {
        if (n.pLandID === action.landId) {
          return action.data.results[0];
        }
        return n;
      });
      return state.setIn(['land', 'data'], fromJS(newLand));

    case propertyActions.PROPERTY_DELETE_LAND[SUCCESS]:
      newLand = state.getIn(['land', 'data']).toJS();
      newLand = newLand.filter((n) => n.pLandID !== action.landId);
      return state.setIn(['land', 'data'], fromJS(newLand));

    // LAND NOTES
    case propertyActions.PROPERTY_FETCH_LAND_NOTES[START]:
      newState = state.setIn(['landNotes', 'data'], fromJS(null));
      return newState.setIn(['landNotes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_LAND_NOTES[SUCCESS]:
      newState = state.setIn(['landNotes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['landNotes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_LAND_NOTES[ERROR]:
      return state.setIn(['landNotes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_LAND_NOTE[SUCCESS]:
      let newLandNotes = state.getIn(['landNotes', 'data']).toJS();
      newLandNotes = newLandNotes.concat(action.data.results);
      return state.setIn(['landNotes', 'data'], fromJS(newLandNotes));

    case propertyActions.PROPERTY_UPDATE_LAND_NOTE[SUCCESS]:
      newLandNotes = state.getIn(['landNotes', 'data']).toJS();
      newLandNotes = newLandNotes.filter((n) => n.pNoteID !== action.noteId);
      newLandNotes = newLandNotes.concat(action.data.results);
      return state.setIn(['landNotes', 'data'], fromJS(newLandNotes));

    case propertyActions.PROPERTY_DELETE_LAND_NOTE[SUCCESS]:
      newLandNotes = state.getIn(['landNotes', 'data']).toJS();
      newLandNotes = newLandNotes.filter((n) => n.pNoteID !== action.noteId);
      return state.setIn(['landNotes', 'data'], fromJS(newLandNotes));

    case propertyActions.PROPERTY_FETCH_SUBCOMPONENT_CONFIG[START]:
    case propertyActions.FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[START]:
      newState = state.setIn(
        ['subcomponent', action.subcomponentType, 'data'],
        fromJS(null),
      );
      return newState.setIn(
        ['subcomponent', action.subcomponentType, 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_SUBCOMPONENT_CONFIG[SUCCESS]:
    case propertyActions.FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[SUCCESS]:
      newState = state.setIn(
        ['subcomponent', action.subcomponentType, 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['subcomponent', action.subcomponentType, 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_SUBCOMPONENT_CONFIG[ERROR]:
    case propertyActions.FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[ERROR]:
      return state.setIn(
        ['subcomponent', action.subcomponentType, 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_OWNERS[START]:
      newState = state.setIn(['owners', 'data'], fromJS(null));
      return newState.setIn(['owners', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_OWNERS[SUCCESS]:
      newState = state.setIn(['owners', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['owners', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_OWNERS[ERROR]:
      return state.setIn(['owners', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[START]:
      newState = state.setIn(['taxOfficeIdentifier', 'data'], fromJS(null));
      return newState.setIn(
        ['taxOfficeIdentifier', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[SUCCESS]:
      newState = state.setIn(
        ['taxOfficeIdentifier', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['taxOfficeIdentifier', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[ERROR]:
      return state.setIn(['taxOfficeIdentifier', 'state'], fetchingState.ERROR);

    // EXEMPTIONS
    case propertyActions.PROPERTY_FETCH_EXEMPTIONS[START]:
      newState = state.setIn(['pExemptions', 'data'], fromJS(null));
      return newState.setIn(['pExemptions', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_EXEMPTIONS[SUCCESS]:
      newState = state.setIn(['pExemptions', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['pExemptions', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_EXEMPTIONS[ERROR]:
      return state.setIn(['pExemptions', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CLEAR_EXEMPTIONS:
      return state.setIn(['pExemptions', 'data'], fromJS([]));

    case propertyActions.PROPERTY_DELETE_EXEMPTION[SUCCESS]:
      newState = state.getIn(['pExemptions', 'data']).toJS();
      newState = newState.filter((n) => n.pExemptionID !== action.pExemptionId);
      return state.setIn(['pExemptions', 'data'], fromJS(newState));

    // EVENTS
    case propertyActions.UPDATE_EVENT_SEARCH_VALUE: {
      return state.setIn(['events', 'eventSearchValue'], action.payload);
    }
    case propertyActions.PROPERTY_FETCH_EVENTS[START]: {
      return state
        .setIn(['events', 'data'], fromJS([]))
        .setIn(['events', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_EVENTS[SUCCESS]: {
      return state
        .setIn(['events', 'state'], fetchingState.LOADED)
        .setIn(['events', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case propertyActions.PROPERTY_FETCH_EVENTS[ERROR]: {
      return state.setIn(['events', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_DELETE_EVENT[SUCCESS]: {
      return state.setIn(
        ['events', 'data'],
        fromJS(
          state
            .getIn(['events', 'data'])
            .toJS()
            .filter((e) => e.eventID !== action.eventID),
        ),
      );
    }

    // ADJUSTMENTS - IMPROVEMENT
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[START]:
      newState = state.setIn(['allImprvAdjustments', 'data'], fromJS(null));
      return newState.setIn(
        ['allImprvAdjustments', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[SUCCESS]:
      newState = state.setIn(
        ['allImprvAdjustments', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['allImprvAdjustments', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[ERROR]:
      return state.setIn(['allImprvAdjustments', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[START]:
      newState = state.setIn(['imprvAdjustTypes', 'data'], fromJS(null));
      return newState.setIn(
        ['imprvAdjustTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[SUCCESS]:
      newState = state.setIn(
        ['imprvAdjustTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['imprvAdjustTypes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[ERROR]:
      return state.setIn(['imprvAdjustTypes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvAdjustments', 'data']).toJS();
      newState = newState.concat(action.data.results);
      return state.setIn(['allImprvAdjustments', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      return state.setIn(['allImprvAdjustments', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      newState = newState.concat(action.data.results);
      return state.setIn(['allImprvAdjustments', 'data'], fromJS(newState));

    // ADJUSTMENTS - LAND
    case propertyActions.PROPERTY_FETCH_LAND_ADJUSTMENTS[START]:
      newState = state.setIn(['allLandAdjustments', 'data'], fromJS(null));
      return newState.setIn(
        ['allLandAdjustments', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_LAND_ADJUSTMENTS[SUCCESS]:
      newState = state.setIn(
        ['allLandAdjustments', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['allLandAdjustments', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_LAND_ADJUSTMENTS[ERROR]:
      return state.setIn(['allLandAdjustments', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_LAND_ADJUST_TYPES[START]:
      newState = state.setIn(['landAdjustTypes', 'data'], fromJS(null));
      return newState.setIn(
        ['landAdjustTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_LAND_ADJUST_TYPES[SUCCESS]:
      newState = state.setIn(
        ['landAdjustTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['landAdjustTypes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_LAND_ADJUST_TYPES[ERROR]:
      return state.setIn(['landAdjustTypes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_LAND_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allLandAdjustments', 'data']).toJS();
      newState = newState.concat(action.data.results);
      return state.setIn(['allLandAdjustments', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_DELETE_LAND_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allLandAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      return state.setIn(['allLandAdjustments', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_UPDATE_LAND_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allLandAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      newState = newState.concat(action.data.results);
      return state.setIn(['allLandAdjustments', 'data'], fromJS(newState));

    // ADJUSTMENTS - IMPROVEMENT DETAIL
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[START]:
      newState = state.setIn(
        ['allImprvDetailAdjustments', 'data'],
        fromJS(null),
      );
      return newState.setIn(
        ['allImprvDetailAdjustments', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[SUCCESS]:
      newState = state.setIn(
        ['allImprvDetailAdjustments', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['allImprvDetailAdjustments', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[ERROR]:
      return state.setIn(
        ['allImprvDetailAdjustments', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[START]:
      newState = state.setIn(['imprvDetailAdjustTypes', 'data'], fromJS(null));
      return newState.setIn(
        ['imprvDetailAdjustTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[SUCCESS]:
      newState = state.setIn(
        ['imprvDetailAdjustTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['imprvDetailAdjustTypes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[ERROR]:
      return state.setIn(
        ['imprvDetailAdjustTypes', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvDetailAdjustments', 'data']).toJS();
      newState = newState.concat(action.data.results);
      return state.setIn(
        ['allImprvDetailAdjustments', 'data'],
        fromJS(newState),
      );

    case propertyActions.PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvDetailAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      return state.setIn(
        ['allImprvDetailAdjustments', 'data'],
        fromJS(newState),
      );

    case propertyActions.PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS]:
      newState = state.getIn(['allImprvDetailAdjustments', 'data']).toJS();
      newState = newState.filter(
        (t) => t.pAdjustmentID !== action.pAdjustmentId,
      );
      newState = newState.concat(action.data.results);
      return state.setIn(
        ['allImprvDetailAdjustments', 'data'],
        fromJS(newState),
      );

    // INFLUENCER - LAND
    case propertyActions.PROPERTY_FETCH_LAND_INFLUENCER[START]:
      newState = state.setIn(['landInfluencer', 'data'], fromJS(null));
      return newState.setIn(
        ['landInfluencer', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_LAND_INFLUENCER[SUCCESS]:
      newState = state.setIn(['landInfluencer', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['landInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_LAND_INFLUENCER[ERROR]:
      return state.setIn(['landInfluencer', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_LAND_INFLUENCER[SUCCESS]:
      // newLand = state.getIn(['land', 'data']).toJS();
      // for (let x = 0; x < newLand.length; x++) {
      //   if (
      //     newLand[x].pLandID === action.landId &&
      //     action.data.results &&
      //     action.data.results[0]
      //   ) {
      //     newLand[x].mktEconomicAdj = action.data.results[0].mktEconomicAdj;
      //     newLand[x].mktEconomicNote = action.data.results[0].mktEconomicNote;
      //     newLand[x].mktFunctionalAdj = action.data.results[0].mktFunctionalAdj;
      //     newLand[x].mktFunctionalNote =
      //       action.data.results[0].mktFunctionalNote;
      //     newLand[x].mktPhysicalAdj = action.data.results[0].mktPhysicalAdj;
      //     newLand[x].mktPhysicalNote = action.data.results[0].mktPhysicalNote;
      //   }
      // }
      newState = state.setIn(['landInfluencer', 'state'], fetchingState.LOADED);
      // .setIn(['land', 'data'], fromJS(newLand));
      return newState.setIn(
        ['landInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_MARKET_MODIFIERS[START]:
      newState = state.setIn(['marketModifiers', 'data'], fromJS(null));
      return newState.setIn(
        ['marketModifiers', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_MARKET_MODIFIERS[SUCCESS]:
      newState = state.setIn(
        ['marketModifiers', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['marketModifiers', 'data'],
        fromJS(action.data ? action.data : null),
      );
    case propertyActions.PROPERTY_FETCH_MARKET_MODIFIERS[ERROR]:
      return state.setIn(['marketModifiers', 'state'], fetchingState.ERROR);

    // INFLUENCER - LAND
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[START]:
      newState = state.setIn(['improvementInfluencer', 'data'], fromJS(null));
      return newState.setIn(
        ['improvementInfluencer', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[SUCCESS]:
      newState = state.setIn(
        ['improvementInfluencer', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[ERROR]:
      return state.setIn(
        ['improvementInfluencer', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER[SUCCESS]:
      newState = state.setIn(
        ['improvementInfluencer', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['improvementInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );

    // INFLUENCER - IMPROVEMENT DETAIL
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[START]:
      newState = state.setIn(['imprvDetailInfluencer', 'data'], fromJS(null));
      return newState.setIn(
        ['imprvDetailInfluencer', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[SUCCESS]:
      newState = state.setIn(
        ['imprvDetailInfluencer', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['imprvDetailInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[ERROR]:
      return state.setIn(
        ['imprvDetailInfluencer', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER[SUCCESS]:
      newState = state.setIn(
        ['imprvDetailInfluencer', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['imprvDetailInfluencer', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );

    case propertyActions.PROPERTY_RECALCULATE[START]:
      newState = state.setIn(['recalculate', 'data'], fromJS(null));
      return newState.setIn(['recalculate', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_RECALCULATE[SUCCESS]:
      newState = state.setIn(['recalculate', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['recalculate', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_RECALCULATE[ERROR]:
      return state.setIn(['recalculate', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_SIZE[START]:
      newState = state.setIn(['size', 'data'], fromJS(null));
      return newState.setIn(['size', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_SIZE[SUCCESS]:
      newState = state.setIn(['size', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['size', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_SIZE[ERROR]:
      return state.setIn(['size', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_EXEMPTION_CARD[START]:
      newState = state.setIn(['exemptionCard', 'data'], fromJS(null));
      return newState.setIn(['exemptionCard', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_EXEMPTION_CARD[SUCCESS]:
      newState = state.setIn(['exemptionCard', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['exemptionCard', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.PROPERTY_FETCH_EXEMPTION_CARD[ERROR]:
      return state.setIn(['exemptionCard', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_VALUE_SUMMARY[START]:
      newState = state.setIn(['valueSummary', 'data'], fromJS(null));
      return newState.setIn(['valueSummary', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_VALUE_SUMMARY[SUCCESS]:
      newState = state.setIn(['valueSummary', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['valueSummary', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_VALUE_SUMMARY[ERROR]:
      return state.setIn(['valueSummary', 'state'], fetchingState.ERROR);

    case propertyActions.ZILLOW_ZESTIMATE_FETCH[START]:
      return state.setIn(['zestimate', 'state'], fetchingState.FETCHING);
    case propertyActions.ZILLOW_ZESTIMATE_FETCH[SUCCESS]:
      newState = state.setIn(['zestimate', 'state'], fetchingState.LOADED);
      return newState.setIn(['zestimate', 'data'], fromJS(action.data.results));
    case propertyActions.ZILLOW_ZESTIMATE_FETCH[ERROR]:
      return state.setIn(['zestimate', 'state'], fetchingState.ERROR);

    case propertyActions.ZILLOW_ZPROPERTY_FETCH[START]:
      return state.setIn(['zProperty', 'state'], fetchingState.FETCHING);
    case propertyActions.ZILLOW_ZPROPERTY_FETCH[SUCCESS]:
      newState = state.setIn(['zProperty', 'state'], fetchingState.LOADED);
      return newState.setIn(['zProperty', 'data'], fromJS(action.data.results));
    case propertyActions.ZILLOW_ZPROPERTY_FETCH[ERROR]:
      return state.setIn(['zProperty', 'state'], fetchingState.ERROR);

    case propertyActions.ZILLOW_ZCOMPS_FETCH[START]:
      return state.setIn(['zComps', 'state'], fetchingState.FETCHING);
    case propertyActions.ZILLOW_ZCOMPS_FETCH[SUCCESS]:
      newState = state.setIn(['zComps', 'state'], fetchingState.LOADED);
      return newState.setIn(['zComps', 'data'], fromJS(action.data.results));
    case propertyActions.ZILLOW_ZCOMPS_FETCH[ERROR]:
      return state.setIn(['zComps', 'state'], fetchingState.ERROR);

    case propertyActions.ZILLOW_PROPERTY_HEADER_FETCH[START]:
      return state.setIn(['zHeader', 'state'], fetchingState.FETCHING);
    case propertyActions.ZILLOW_PROPERTY_HEADER_FETCH[SUCCESS]:
      newState = state.setIn(['zHeader', 'state'], fetchingState.LOADED);
      return newState.setIn(['zHeader', 'data'], fromJS(action.data.results));
    case propertyActions.ZILLOW_PROPERTY_HEADER_FETCH[ERROR]:
      return state.setIn(['zHeader', 'state'], fetchingState.ERROR);

    // PROPERTY LOOKUP MODAL
    case propertyActions.OPEN_PROPERTY_LOOKUP_MODAL:
      const data = {
        open: true,
        mode: action.payload.mode,
        futureYear: action.payload.futureYear ? true : false,
        marketLookup: action.payload.marketLookup || false,
        currentValuation: action.payload.currentValuation,
        addPropertyToSG: action.payload.addPropertyToSG,
        addPropertyToBP: action.payload.addPropertyToBP,
        searchParams: action.payload.searchParams || [],
        primarySearchFields: action.payload.primarySearchFields || [],
        primaryResultFields: action.payload.primaryResultFields || [],
        selection: [],
        state: '',
        data: [],
        count: 0,
      };
      newState = state.getIn(['propertyLookupModal']).toJS();

      if (action.payload.keepData) {
        data.state = newState.state;
        data.data = newState.data;
        data.count = newState.count;
      }
      return state.set('propertyLookupModal', fromJS(data));

    case propertyActions.CLOSE_PROPERTY_LOOKUP_MODAL:
      return state.setIn(['propertyLookupModal', 'open'], false);

    case propertyActions.LOOKUP_PROPERTY[START]:
      return state.setIn(
        ['propertyLookupModal', 'state'],
        fetchingState.FETCHING,
      );

    case propertyActions.LOOKUP_PROPERTY[SUCCESS]:
      return state
        .setIn(['propertyLookupModal', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyLookupModal', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['propertyLookupModal', 'count'],
          _.get(action, 'data.totalProperty.propertyCount', 0),
        );

    case propertyActions.LOOKUP_PROPERTY[ERROR]:
      return state.setIn(['propertyLookupModal', 'state'], fetchingState.ERROR);

    case propertyActions.MODAL_SELECT_PROPERTY_RECORDS:
      return state.setIn(['propertyLookupModal', 'selection'], action.payload);

    case propertyActions.PROPERTY_MASS_CREATE_FETCH[START]:
      return state.setIn(['massCreate', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_MASS_CREATE_FETCH[SUCCESS]:
      newState = state.setIn(['massCreate', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['massCreate', 'data'],
        fromJS(action.data.results),
      );
    case propertyActions.PROPERTY_MASS_CREATE_FETCH[ERROR]:
      return state.setIn(['massCreate', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[START]:
      return state.setIn(['createMassCreate', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[SUCCESS]:
      return state
        .setIn(['createMassCreate', 'state'], fetchingState.LOADED)
        .setIn(
          ['createMassCreate', 'data'],
          action.data ? fromJS(action.data) : {},
        );
    case propertyActions.PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[ERROR]:
      return state
        .setIn(['createMassCreate', 'state'], fetchingState.ERROR)
        .setIn(['createMassCreate', 'data'], fromJS(action.data));

    case propertyActions.PROPERTY_MASS_CREATE_CREATE[START]:
      return state.setIn(['createMassCreate', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_MASS_CREATE_CREATE[SUCCESS]:
      return state
        .setIn(['createMassCreate', 'state'], fetchingState.LOADED)
        .setIn(
          ['createMassCreate', 'data'],
          action.data ? fromJS(action.data) : {},
        );
    case propertyActions.PROPERTY_MASS_CREATE_CREATE[ERROR]:
      return state
        .setIn(['createMassCreate', 'state'], fetchingState.ERROR)
        .setIn(['createMassCreate', 'data'], fromJS(action.data));

    case propertyActions.PROPERTY_MASS_CREATE_PREP_DATA[START]:
      return state.setIn(
        ['massCreatePrepData', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_MASS_CREATE_PREP_DATA[SUCCESS]:
      newState = state.setIn(
        ['massCreatePrepData', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['massCreatePrepData', 'data'],
        fromJS(action.data.results || []),
      );
    case propertyActions.PROPERTY_MASS_CREATE_PREP_DATA[ERROR]:
      return state.setIn(['massCreatePrepData', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_MASS_CREATE_CLEAR_PREP_DATA:
      return state.setIn(['massCreatePrepData', 'data'], fromJS([]));

    case propertyActions.PROPERTY_MASS_CREATE_FINALIZE[SUCCESS]:
      newState = state.getIn(['massCreate', 'data']).toJS();
      const itemIdx = newState.findIndex(
        (item) => item.massCreateID === Number(action.id),
      );
      newState[itemIdx].finalized = 1;
      return state.setIn(['massCreate', 'data'], fromJS(newState));

    // case propertyActions.PROPERTY_MASS_CREATE_DELETE[SUCCESS]:
    //   newState = state.getIn(['massCreate', 'data']).toJS();
    //   newState = newState.filter(
    //     item => item.massCreateID !== Number(action.id),
    //   );
    //   return state.setIn(['massCreate', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[START]:
      return state.setIn(
        ['massCreateSettings', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[SUCCESS]:
      newState = state.setIn(
        ['massCreateSettings', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['massCreateSettings', 'data'],
        fromJS((action.data && action.data.results) || []),
      );
    case propertyActions.PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[ERROR]:
      return state.setIn(['massCreateSettings', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH[START]:
      return state.setIn(
        ['massCreateSetting', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH[SUCCESS]:
      newState = state.setIn(
        ['massCreateSetting', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['massCreateSetting', 'data'],
        fromJS(action.data && action.data.results[0]),
      );
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH[ERROR]:
      return state.setIn(['massCreateSetting', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_MASS_CREATE_SETTING_DELETE[SUCCESS]:
      newState = state.getIn(['massCreateSettings', 'data']).toJS();
      newState = newState.filter(
        (setting) => setting.massCreateSettingID !== action.id,
      );
      return state.setIn(['massCreateSettings', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[
      START
    ]:
      return state.setIn(
        ['massCreateSettingsAvailPropTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[
      SUCCESS
    ]:
      return state
        .setIn(
          ['massCreateSettingsAvailPropTypes', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['massCreateSettingsAvailPropTypes', 'data'],
          action.data ? fromJS(action.data.results) : {},
        );
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[
      ERROR
    ]:
      return state.setIn(
        ['massCreateSettingsAvailPropTypes', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_MASS_CREATE_SETTING_ADD[START]:
      return state.setIn(['massCreateSettings', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_ADD[SUCCESS]:
      newState = state.getIn(['massCreateSettings', 'data']).toJS();
      newState = newState.concat(action.data.results);
      return state.setIn(['massCreateSettings', 'data'], fromJS(newState));
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_ADD[ERROR]:
      return state.setIn(['massCreateSettings', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_MASS_CREATE_SETTING_EDIT[START]:
      return state.setIn(['massCreateSettings', 'state'], fetchingState.SAVING);
    case propertyActions.PROPERTY_MASS_CREATE_SETTING_EDIT[SUCCESS]:
      newState = state.getIn(['massCreateSettings', 'data']).toJS();
      newState = newState.filter(
        (n) => n.massCreateSettingID !== Number(action.id),
      );
      newState = newState.concat(action.data.results[0]);
      return state.setIn(['massCreateSettings', 'data'], fromJS(newState));

    case propertyActions.PROPERTY_MASS_CREATE_PROPERTIES[START]:
      return state.setIn(
        ['massCreateProperties', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_MASS_CREATE_PROPERTIES[SUCCESS]:
      newState = state.setIn(
        ['massCreateProperties', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['massCreateProperties', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_MASS_CREATE_PROPERTIES[ERROR]:
      return state.setIn(
        ['massCreateProperties', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_EXEMPTION_RESET_UPDATE[SUCCESS]: {
      return state.setIn(['property', 'state'], fetchingState.LOADED).setIn(
        ['property', 'data'],
        fromJS({
          ...state.getIn(['property', 'data']).toJS(),
          ..._.get(action, 'data.results[0]', {}),
        }),
      );
    }

    case propertyActions.WALKTHROUGH_SETTINGS_FETCH_ALL[START]:
      return state.setIn(
        ['walkthroughSettings', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.WALKTHROUGH_SETTINGS_FETCH_ALL[SUCCESS]:
      newState = state.setIn(
        ['walkthroughSettings', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['walkthroughSettings', 'data'],
        fromJS((action.data && action.data.results) || []),
      );
    case propertyActions.WALKTHROUGH_SETTINGS_FETCH_ALL[ERROR]:
      return state.setIn(['walkthroughSettings', 'state'], fetchingState.ERROR);

    case propertyActions.WALKTHROUGH_SETTING_DELETE[SUCCESS]:
      newState = state.getIn(['walkthroughSettings', 'data']).toJS();
      return state.setIn(
        ['walkthroughSettings', 'data'],
        fromJS(newState.filter((s) => s.walkthruSettingID !== action.id)),
      );

    case propertyActions.WALKTHROUGH_SETTING_UPDATE[SUCCESS]:
      newState = state.getIn(['walkthroughSettings', 'data']).toJS();
      newState = newState.filter((s) => s.walkthruSettingID !== action.id);
      newState = newState.concat(action.data.results);
      return state.setIn(['walkthroughSettings', 'data'], fromJS(newState));

    case propertyActions.ADD_MERGE_PROPERTY:
      newState = state.get('mergeProperties').toJS();
      return state.setIn(
        ['mergeProperties'],
        fromJS([...newState, action.data]),
      );

    case propertyActions.REMOVE_MERGE_PROPERTY:
      newState = state.get('mergeProperties').toJS();
      return state.setIn(
        ['mergeProperties'],
        fromJS(newState.filter((p) => p.pid !== action.data)),
      );

    case propertyActions.RESET_MERGE_PROPERTY:
      newState = state.setIn(['mergeProperties'], fromJS([]));
      return newState.setIn(['mergedProperty'], fromJS({}));

    case propertyActions.CREATE_PROPERTY_MERGE[START]:
      return state.setIn(['mergedProperty', 'state'], fetchingState.FETCHING);
    case propertyActions.CREATE_PROPERTY_MERGE[SUCCESS]:
      newState = state.setIn(['mergedProperty', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['mergedProperty', 'data'],
        fromJS({
          ...action.data.property,
          ...action.data.results[0],
        }),
      );
    case propertyActions.CREATE_PROPERTY_MERGE[ERROR]:
      return state.setIn(['mergedProperty', 'state'], fetchingState.ERROR);

    case propertyActions.CREATE_PROPERTY_SPLIT[START]:
      return state.setIn(['splitProperty', 'state'], fetchingState.FETCHING);
    case propertyActions.CREATE_PROPERTY_SPLIT[SUCCESS]:
      newState = state.setIn(['splitProperty', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['splitProperty', 'data'],
        fromJS(action.data.results || []),
      );
    case propertyActions.CREATE_PROPERTY_SPLIT[ERROR]:
      return state.setIn(['splitProperty', 'state'], fetchingState.ERROR);
    case propertyActions.UPDATE_OWNERSHIP_PERCENT[START]:
      return state.setIn(
        ['updateOwnershipPercent', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.UPDATE_OWNERSHIP_PERCENT[SUCCESS]:
      newState = state
        .setIn(['updateOwnershipPercent', 'state'], fetchingState.LOADED)
        .setIn(
          ['updateOwnershipPercent', 'data'],
          fromJS(action.data.results || []),
        )
        .setIn(['owners', 'data'], fromJS(action.data.results || []));
      return newState;
    case propertyActions.UPDATE_OWNERSHIP_PERCENT[ERROR]:
      return state.setIn(
        ['updateOwnershipPercent', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.UPDATE_LEGAL_ACREAGE[START]:
      return state.setIn(['updateAcreage', 'state'], fetchingState.FETCHING);
    case propertyActions.UPDATE_LEGAL_ACREAGE[SUCCESS]: {
      const splitProperty = state.getIn(['splitProperty', 'data']).toJS();
      for (let x = 0; x < splitProperty.length; x++) {
        if (splitProperty[x].pID === action.data.results[0].pID) {
          splitProperty[x].legalAcreage = action.data.results[0].legalAcreage;
        }
      }
      newState = state
        .setIn(['updateAcreage', 'state'], fetchingState.LOADED)
        .setIn(['updateAcreage', 'data'], fromJS(action.data.results || []))
        .setIn(['splitProperty', 'data'], fromJS(splitProperty));
      return newState;
    }
    case propertyActions.UPDATE_LEGAL_ACREAGE[ERROR]:
      return state.setIn(['updateAcreage', 'state'], fetchingState.ERROR);
    case propertyActions.GET_PROPERTY_INACTIVE_REASONS[START]:
      return state.setIn(
        ['propertyInactiveReasons', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.GET_PROPERTY_INACTIVE_REASONS[SUCCESS]:
      newState = state
        .setIn(['propertyInactiveReasons', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyInactiveReasons', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
      return newState;
    case propertyActions.GET_PROPERTY_INACTIVE_REASONS[ERROR]:
      return state.setIn(
        ['propertyInactiveReasons', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.GET_PROPERTY_REACTIVATE_REASONS[START]:
      return state.setIn(
        ['propertyInactiveReasons', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.GET_PROPERTY_REACTIVATE_REASONS[SUCCESS]:
      newState = state
        .setIn(['propertyInactiveReasons', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyInactiveReasons', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
      return newState;
    case propertyActions.GET_PROPERTY_REACTIVATE_REASONS[ERROR]:
      return state.setIn(
        ['propertyInactiveReasons', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_INACTIVATE[START]:
      return state.setIn(
        ['propertyInactivate', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_INACTIVATE[SUCCESS]:
      let property = state.getIn(['property', 'data']).toJS();
      if (action.data.results) {
        property.inactivatedBy = action.data.results[0].inactivatedBy;
        property.inactive = action.data.results[0].inactive;
        property.inactiveDt = action.data.results[0].inactiveDt;
        property.inactiveNotes = action.data.results[0].inactiveNotes;
        property.inactiveReason = action.data.results[0].inactiveReason;
      }
      newState = state
        .setIn(['propertyInactivate', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyInactivate', 'data'],
          fromJS(action.data.results || []),
        )
        .setIn(['property', 'data'], fromJS(property));
      return newState;
    case propertyActions.PROPERTY_INACTIVATE[ERROR]:
      return state.setIn(['propertyInactivate', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_REACTIVATE[START]:
      return state.setIn(
        ['propertyInactivate', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_REACTIVATE[SUCCESS]:
      property = state.getIn(['property', 'data']).toJS();
      if (action.data.results) {
        property.reactivateBy = action.data.results[0].reactivateBy;
        property.inactive = action.data.results[0].inactive;
        property.reactivateDt = action.data.results[0].reactivateDt;
        property.reactivateNotes = action.data.results[0].reactivateNotes;
        property.reactivateReason = action.data.results[0].reactivateReason;
      }
      newState = state
        .setIn(['propertyInactivate', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyInactivate', 'data'],
          fromJS(action.data.results || []),
        )
        .setIn(['property', 'data'], fromJS(property));
      return newState;
    case propertyActions.PROPERTY_REACTIVATE[ERROR]:
      return state.setIn(['propertyInactivate', 'state'], fetchingState.ERROR);

    case propertyActions.GET_SPLIT_REASONS[START]:
      return state.setIn(['splitReasons', 'state'], fetchingState.FETCHING);
    case propertyActions.GET_SPLIT_REASONS[SUCCESS]:
      return state
        .setIn(['splitReasons', 'state'], fetchingState.LOADED)
        .setIn(['splitReasons', 'data'], fromJS(action.data.results || []));
    case propertyActions.GET_SPLIT_REASONS[ERROR]:
      return state.setIn(['splitReasons', 'state'], fetchingState.ERROR);

    case propertyActions.RESET_PROPERTY_SPLIT_DATA:
      newState = state.setIn(['splitProperties'], fromJS([]));
      return newState.setIn(['splitProperty'], fromJS({}));

    case propertyActions.FETCH_APPLICATIONS_START: {
      return state.setIn(['applications', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_APPLICATION[SUCCESS]:
    case propertyActions.FETCH_APPLICATIONS_SUCCESS: {
      return state
        .setIn(['applications', 'state'], fetchingState.LOADED)
        .setIn(
          ['applications', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case propertyActions.RESET_APPLICATIONS:
      return state
        .setIn(['applications', 'state'], null)
        .setIn(['applications', 'data'], fromJS([]));
    case propertyActions.UPDATE_APPLICATION_FILE_SUCCESS:
    case propertyActions.DELETE_APPLICATION_FILE_SUCCESS:
    case propertyActions.UPLOAD_APPLICATION_FILE_SUCCESS: {
      const fileAttachment = _.get(action, 'data.results.0.fileAttachment');
      const updateDt = _.get(action, 'data.results.0.updateDt');
      const applicationID = _.get(action, 'data.results.0.applicationID');

      return state.updateIn(['applications', 'data'], (data) => {
        const index = data.findIndex(
          (v) => v.get('applicationID') === applicationID,
        );
        return data.update(index, (app) =>
          app
            .set('fileAttachment', fromJS(fileAttachment))
            .set('updateDt', updateDt),
        );
      });
    }

    case propertyActions.FETCH_APPLICATION_EXEMPTIONS_START: {
      return state.setIn(['exemptions', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_APPLICATION_EXEMPTIONS_SUCCESS: {
      return state
        .setIn(['exemptions', 'state'], fetchingState.LOADED)
        .setIn(['exemptions', 'data'], fromJS(_.get(action, 'data.results')));
    }

    case propertyActions.FETCH_APPLICATION_PROPERTY_LIST[START]: {
      return state.setIn(
        ['exemptions', 'propetyList', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_APPLICATION_PROPERTY_LIST[SUCCESS]: {
      return state
        .setIn(['exemptions', 'propertyList', 'state'], fetchingState.LOADED)
        .setIn(
          ['exemptions', 'propertyList', 'data'],
          action.data ? action.data.results : fromJS([]),
        );
    }
    case propertyActions.FETCH_APPLICATION_PROPERTY_LIST[ERROR]: {
      /* console.log('FETCH_APPLICATION_PROPERTY_LIST - ERROR'); */
      return state.setIn(
        ['exemptions', 'propertyList', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.CREATE_SINGLE_PROPERTY[START]:
      return state.setIn(['singleCreate', 'state'], fetchingState.SAVING);
    case propertyActions.CREATE_SINGLE_PROPERTY[SUCCESS]:
      newState = state.setIn(['singleCreate', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['singleCreate', 'data'],
        fromJS(action.data.results[0]),
      );
    case propertyActions.CREATE_SINGLE_PROPERTY[ERROR]:
      return state.setIn(['singleCreate', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[START]:
      return state.setIn(
        ['propCreateSettingsAvailPropTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[
      SUCCESS
    ]:
      return state
        .setIn(
          ['propCreateSettingsAvailPropTypes', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['propCreateSettingsAvailPropTypes', 'data'],
          action.data ? fromJS(action.data.results) : fromJS([]),
        );
    case propertyActions.PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[ERROR]:
      return state.setIn(
        ['propCreateSettingsAvailPropTypes', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.FETCH_APPLICATION_TYPE_SUCCESS: {
      return state.setIn(
        ['applications', 'codefiles', 'type'],
        fromJS(_.get(action, 'data.results')),
      );
    }
    case propertyActions.FETCH_APPLICATION_STATUS_SUCCESS: {
      return state.setIn(
        ['applications', 'codefiles', 'status'],
        fromJS(_.get(action, 'data.results')),
      );
    }
    case propertyActions.FETCH_APPLICATION_OWNERS_SUCCESS: {
      return state.setIn(
        ['applications', 'codefiles', 'owners'],
        fromJS(_.get(action, 'data.results')),
      );
    }
    case propertyActions.FETCH_APPLICATION_ID_TYPE_SUCCESS: {
      return state.setIn(
        ['applications', 'codefiles', 'idType'],
        fromJS(_.get(action, 'data.results')),
      );
    }

    case propertyActions.CREATE_APPLICATION_SUCCESS: {
      return state.setIn(
        ['applications', 'data'],
        fromJS(
          [_.get(action, 'data.results.0')].concat(
            state.getIn(['applications', 'data']).toJS(),
          ),
        ),
      );
    }

    case propertyActions.DELETE_APPLICATION_SUCCESS: {
      return state.setIn(
        ['applications', 'data'],
        fromJS(
          state
            .getIn(['applications', 'data'])
            .toJS()
            .filter((x) => x.applicationID !== action.applicationId),
        ),
      );
    }

    case propertyActions.COMPLETE_APPLICATION[SUCCESS]:
    case propertyActions.COMPLETE_APPLICATION_MULTI_YEAR[SUCCESS]:
    case propertyActions.UPDATE_APPLICATION_SUCCESS: {
      return state.setIn(
        ['applications', 'data'],
        fromJS(
          state
            .getIn(['applications', 'data'])
            .toJS()
            .map((x) =>
              x.applicationID !== action.data.results[0].applicationID
                ? x
                : action.data.results[0],
            ),
        ),
      );
    }

    case propertyActions.FETCH_EXEMPTION_CODEFILES_SUCCESS: {
      return state.setIn(
        ['exemptions', 'codefiles', 'codes'],
        fromJS(_.get(action, 'data.results')),
      );
    }
    case propertyActions.FETCH_EXEMPTION_YEARS_SUCCESS: {
      return state.setIn(
        ['exemptions', 'codefiles', 'years'],
        fromJS(_.get(action, 'data.results')),
      );
    }
    case propertyActions.FETCH_EXEMPTION_YEARS_ERROR: {
      return state.setIn(
        ['exemptions', 'codefiles', 'years'],
        fromJS([2016, 2017, 2018]),
      );
    }

    case propertyActions.FETCH_APPLICATION_ROLL_CORRECTION_CODES_START: {
      return state.setIn(
        ['exemptions', 'rollCorrectionCodes', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_APPLICATION_ROLL_CORRECTION_CODES_SUCCESS: {
      newState = state.setIn(
        ['exemptions', 'rollCorrectionCodes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['exemptions', 'rollCorrectionCodes', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );
    }
    case propertyActions.FETCH_APPLICATION_ROLL_CORRECTION_CODES_ERROR: {
      return state.setIn(
        ['exemptions', 'rollCorrectionCodes', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.CLEAR_EXEMPTIONS:
      return state.setIn(['exemptions', 'data'], fromJS([]));

    case propertyActions.CREATE_EXEMPTION_SUCCESS: {
      return state.setIn(
        ['exemptions', 'data'],
        fromJS([
          ...(state.getIn(['exemptions', 'data'])
            ? state.getIn(['exemptions', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );
    }

    case propertyActions.UPDATE_EXEMPTION_SUCCESS: {
      const result = _.get(action, 'data.results[0]', {});
      const id = _.get(result, 'applicationExemptionID');

      return state.updateIn(['exemptions', 'data'], (data) => {
        const index = data.findIndex(
          (ex) => ex.get('applicationExemptionID') === id,
        );
        return index !== -1 ? data.set(index, fromJS(result)) : data;
      });
    }
    case propertyActions.DELETE_EXEMPTION_SUCCESS: {
      return state.setIn(
        ['exemptions', 'data'],
        fromJS(
          state
            .getIn(['exemptions', 'data'])
            .toJS()
            .filter(
              (x) => x.applicationExemptionID !== action.applicationExemptionID,
            ),
        ),
      );
    }
    case propertyActions.UNDO_EXEMPTION_SUCCESS:
    case propertyActions.DENY_EXEMPTION_SUCCESS:
    case propertyActions.APPROVE_EXEMPTION_SUCCESS: {
      return state.setIn(
        ['exemptions', 'data'],
        fromJS(
          state
            .getIn(['exemptions', 'data'])
            .toJS()
            .map((x) =>
              x.applicationExemptionID ===
              _.get(action, 'data.results[0].applicationExemptionID')
                ? action.data.results[0]
                : x,
            ),
        ),
      );
    }

    case propertyActions.FETCH_ALL_VALUATIONS_BPP[START]:
      newState = state.setIn(['valuationsBpp', 'data'], fromJS(null));
      return newState.setIn(['valuationsBpp', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_ALL_VALUATIONS_BPP[SUCCESS]:
      newState = state.setIn(['valuationsBpp', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['valuationsBpp', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.FETCH_ALL_VALUATIONS_BPP[ERROR]:
      return state.setIn(['valuationsBpp', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_CREATE_VALUATION_BPP[SUCCESS]:
      let newValuationsBpp =
        (state.getIn(['valuationsBpp', 'data']) &&
          state.getIn(['valuationsBpp', 'data']).toJS()) ||
        [];
      newValuationsBpp = newValuationsBpp.concat(action.data.results);
      return state.setIn(['valuationsBpp', 'data'], fromJS(newValuationsBpp));

    case propertyActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[START]:
      newState = state.setIn(
        ['personalDepreciationCategoryMethod', 'data'],
        fromJS(null),
      );
      return newState.setIn(
        ['personalDepreciationCategoryMethod', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[SUCCESS]:
      newState = state.setIn(
        ['personalDepreciationCategoryMethod', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['personalDepreciationCategoryMethod', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[ERROR]:
      return state.setIn(
        ['personalDepreciationCategoryMethod', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_PERSONAL_DETAIL_SUMMARY[START]:
      newState = state.setIn(['personalDetailSummary', 'data'], fromJS(null));
      return newState.setIn(
        ['personalDetailSummary', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PERSONAL_DETAIL_SUMMARY[SUCCESS]:
      newState = state.setIn(
        ['personalDetailSummary', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['personalDetailSummary', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case propertyActions.FETCH_PERSONAL_DETAIL_SUMMARY[ERROR]:
      return state.setIn(
        ['personalDetailSummary', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_ALL_PERSONAL_DETAILS[START]:
      newState = state.setIn(['allPersonalDetails', 'data'], fromJS(null));
      return newState.setIn(
        ['allPersonalDetails', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_ALL_PERSONAL_DETAILS[SUCCESS]:
      newState = state.setIn(
        ['allPersonalDetails', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['allPersonalDetails', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_ALL_PERSONAL_DETAILS[ERROR]:
      return state.setIn(['allPersonalDetails', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_PERSONAL_DETAIL[START]:
      newState = state.setIn(['personalDetail', 'data'], fromJS(null));
      return newState.setIn(
        ['personalDetail', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PERSONAL_DETAIL[SUCCESS]:
      newState = state.setIn(['personalDetail', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['personalDetail', 'data'],
        fromJS(action.data ? action.data.results[0] : []),
      );
    case propertyActions.FETCH_PERSONAL_DETAIL[ERROR]:
      return state.setIn(['personalDetail', 'state'], fetchingState.ERROR);

    case propertyActions.INSERT_PERSONAL_DETAIL[SUCCESS]:
      return state.setIn(
        ['allPersonalDetails', 'data'],
        fromJS([
          ...(state.getIn(['allPersonalDetails', 'data'])
            ? state.getIn(['allPersonalDetails', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case propertyActions.UPDATE_PERSONAL_DETAIL[SUCCESS]:
      newState = state.setIn(
        ['personalDetail', 'data'],
        fromJS(action.data ? action.data.results[0] : []),
      );
      return updateStateArrayItem(
        newState,
        action,
        'allPersonalDetails',
        'pDetailID',
      );

    case propertyActions.DELETE_PERSONAL_DETAIL[SUCCESS]:
      newState = state.getIn(['allPersonalDetails', 'data']).toJS();
      return state.setIn(
        ['allPersonalDetails', 'data'],
        fromJS(newState.filter((i) => i.pDetailID !== action.detailId)),
      );

    case propertyActions.DELETE_ALL_PERSONAL_DETAILS[SUCCESS]:
      return state.setIn(['allPersonalDetails', 'data'], fromJS([]));

    case propertyActions.FETCH_PERSONAL_DETAIL_TAXING_UNITS[START]:
      newState = state.setIn(
        ['personalDetailTaxingUnits', 'data'],
        fromJS(null),
      );
      return newState.setIn(
        ['personalDetailTaxingUnits', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PERSONAL_DETAIL_TAXING_UNITS[SUCCESS]:
      newState = state.setIn(
        ['personalDetailTaxingUnits', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['personalDetailTaxingUnits', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_PERSONAL_DETAIL_TAXING_UNITS[ERROR]:
      return state.setIn(
        ['personalDetailTaxingUnits', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.INSERT_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS]:
      return state.setIn(
        ['personalDetailTaxingUnits', 'data'],
        fromJS([
          ...(state.getIn(['personalDetailTaxingUnits', 'data'])
            ? state.getIn(['personalDetailTaxingUnits', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case propertyActions.UPDATE_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'personalDetailTaxingUnits',
        'pTaxingUnitID',
      );

    case propertyActions.DELETE_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS]:
      newState = state.getIn(['personalDetailTaxingUnits', 'data']).toJS();
      return state.setIn(
        ['personalDetailTaxingUnits', 'data'],
        fromJS(
          newState.filter(
            (i) => i.pDetailTaxingUnitID !== action.detailTaxingUnitId,
          ),
        ),
      );

    case propertyActions.UPDATE_VALUATION_BPP[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'valuationsBpp',
        'pBusinessPropID',
      );

    case propertyActions.FETCH_ALL_RENDITIONS_BPP[START]:
      newState = state.setIn(['renditionsBpp', 'data'], fromJS(null));
      return newState.setIn(['renditionsBpp', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_ALL_RENDITIONS_BPP[SUCCESS]:
      newState = state.setIn(['renditionsBpp', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['renditionsBpp', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_ALL_RENDITIONS_BPP[ERROR]:
      return state.setIn(['renditionsBpp', 'state'], fetchingState.ERROR);

    case propertyActions.RESET_RENDITIONS_BPP:
      return state.setIn(['renditionsBpp'], fromJS({}));

    case propertyActions.INSERT_PERSONAL_RENDITION[SUCCESS]:
      return state.setIn(
        ['renditionsBpp', 'data'],
        fromJS([
          ...(state.getIn(['renditionsBpp', 'data'])
            ? state.getIn(['renditionsBpp', 'data']).toJS()
            : []),
          _.get(action, 'data.results[0]'),
        ]),
      );

    case propertyActions.UPDATE_PERSONAL_RENDITION[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.PERSONAL_RENDITION_ACTIVATE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.PERSONAL_RENDITION_DEACTIVATE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.INSERT_PERSONAL_RENDITION_FILES[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.UPDATE_PERSONAL_RENDITION_FILE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.DELETE_PERSONAL_RENDITION_FILE[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.VERIFY_PERSONAL_RENDITION[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.UNVERIFY_PERSONAL_RENDITION[SUCCESS]:
      return updateStateArrayItem(
        state,
        action,
        'renditionsBpp',
        'pRenditionID',
      );

    case propertyActions.DELETE_PERSONAL_RENDITION[SUCCESS]:
      return state.setIn(
        ['renditionsBpp', 'data'],
        fromJS(
          state
            .getIn(['renditionsBpp', 'data'])
            .toJS()
            .filter((r) => r.pRenditionID !== action.renditionId),
        ),
      );

    case propertyActions.FETCH_PRIMARY_OWNER_DETAILS[START]:
      newState = state.setIn(['primaryOwnerDetails', 'data'], fromJS(null));
      return newState.setIn(
        ['primaryOwnerDetails', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PRIMARY_OWNER_DETAILS[SUCCESS]:
      newState = state.setIn(
        ['primaryOwnerDetails', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['primaryOwnerDetails', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_PRIMARY_OWNER_DETAILS[ERROR]:
      return state.setIn(['primaryOwnerDetails', 'state'], fetchingState.ERROR);

    case propertyActions.CLEAR_PRIMARY_OWNER_DETAILS:
      return state.setIn(['primaryOwnerDetails'], fromJS({}));

    case propertyActions.FETCH_PREVIOUS_YEAR_DETAILS[START]:
      newState = state.setIn(['renditionWalkthruBpp', 'data'], fromJS(null));
      return newState.setIn(
        ['renditionWalkthruBpp', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_PREVIOUS_YEAR_DETAILS[SUCCESS]:
      newState = state.setIn(
        ['renditionWalkthruBpp', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['renditionWalkthruBpp', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_PREVIOUS_YEAR_DETAILS[ERROR]:
      return state.setIn(
        ['renditionWalkthruBpp', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.DELETE_RENDITION_WALKTHRU_DETAIL:
      return state.setIn(
        ['renditionWalkthruBpp', 'data'],
        fromJS(
          state
            .getIn(['renditionWalkthruBpp', 'data'])
            .toJS()
            .filter((d) => d.pDetailID !== action.detailId),
        ),
      );

    case propertyActions.DELETE_ALL_RENDITION_WALKTHRU_DETAILS:
      return state.setIn(['renditionWalkthruBpp', 'data'], fromJS([]));

    case propertyActions.INSERT_RENDITION_WALKTHRU_DETAIL:
      if (action.data.quickEntry) {
        return state.setIn(
          ['renditionWalkthruBpp', 'data'],
          fromJS([
            ...state.getIn(['renditionWalkthruBpp', 'data']).toJS(),
            { ...action.data.data, pDetailID: getRandId() },
          ]),
        );
      }
      return state.setIn(
        ['renditionWalkthruBpp', 'data'],
        fromJS([
          ...state.getIn(['renditionWalkthruBpp', 'data']).toJS(),
          { ...action.data, pDetailID: getRandId() },
        ]),
      );

    case propertyActions.UPDATE_RENDITION_WALKTHRU_DETAIL:
      return state.setIn(
        ['renditionWalkthruBpp', 'data'],
        fromJS(
          state
            .getIn(['renditionWalkthruBpp', 'data'])
            .toJS()
            .map((x) =>
              x.pDetailID === _.get(action, 'data.pDetailID') ? action.data : x,
            ),
        ),
      );

    case propertyActions.SEARCH_APPLICATION_EVENTS_START: {
      return state.setIn(
        ['applicationEvents', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.SEARCH_APPLICATION_EVENTS_SUCCESS: {
      return state
        .setIn(['applicationEvents', 'state'], fetchingState.LOADED)
        .setIn(
          ['applicationEvents', 'data'],
          fromJS(_.get(action, 'data.results')),
        )
        .setIn(
          ['applicationEvents', 'totalEvents'],
          _.get(action, 'data.totalEvents'),
        );
    }
    case propertyActions.DELETE_APPLICATION_EVENTS_SUCCESS: {
      const { eventID } = action;

      return state.updateIn(['applicationEvents', 'data'], (data) =>
        data.filter((e) => e.get('eventID') !== eventID),
      );
    }
    case propertyActions.FETCH_APPLICATION_EVENT_TYPES_SUCCESS: {
      return state.setIn(
        ['applicationEvents', 'eventTypes'],
        _.get(action, 'data.results'),
      );
    }
    case propertyActions.FETCH_APPLICATION_EVENT_FORMS_SUCCESS: {
      return state.setIn(
        ['applicationEvents', 'eventForms'],
        _.get(action, 'data.results'),
      );
    }

    case propertyActions.EXEMPTION_NOTES_FETCH_START: {
      return state.setIn(['exemptionNotes', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.EXEMPTION_NOTES_FETCH_SUCCESS: {
      return state
        .setIn(['exemptionNotes', 'state'], fetchingState.LOADED)
        .setIn(
          ['exemptionNotes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.EXEMPTION_NOTES_FETCH_ERROR: {
      return state.setIn(['exemptionNotes', 'state'], fetchingState.ERROR);
    }

    case propertyActions.EXEMPTION_NOTE_ADD_SUCCESS: {
      return state.setIn(
        ['exemptionNotes', 'data'],
        fromJS(
          state
            .getIn(['exemptionNotes', 'data'])
            .toJS()
            .concat(_.get(action, 'data.results', [])),
        ),
      );
    }
    case propertyActions.EXEMPTION_NOTE_DELETE_SUCCESS: {
      return state.setIn(
        ['exemptionNotes', 'data'],
        fromJS(
          state
            .getIn(['exemptionNotes', 'data'])
            .toJS()
            .filter((note) => note.noteID !== action.noteID),
        ),
      );
    }
    case propertyActions.EXEMPTION_NOTE_UPDATE_SUCCESS: {
      return state.setIn(
        ['exemptionNotes', 'data'],
        fromJS(
          state
            .getIn(['exemptionNotes', 'data'])
            .toJS()
            .filter((n) => n.noteID !== action.noteID)
            .concat(_.get(action, 'data.results', [])),
        ),
      );
    }
    case propertyActions.SET_SELECTDATA: {
      return state.setIn(['select'], fromJS(action.windowData));
    }
    case propertyActions.SET_SPLITPROPERTYDATA: {
      return state.setIn(['splitProperty', 'data'], fromJS(action.windowData));
    }
    case propertyActions.SET_PRINT_CARD_DATA: {
      return state.setIn(['printCard', 'data'], fromJS(action.windowData));
    }

    // property account exemptions
    case propertyActions.PROPERTY_FETCH_EXEMPTION[START]: {
      return state
        .setIn(['pExemption', 'data'], fromJS({}))
        .setIn(['pExemption', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_EXEMPTION[SUCCESS]: {
      return state
        .setIn(['pExemption', 'state'], fetchingState.LOADED)
        .setIn(
          ['pExemption', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case propertyActions.PROPERTY_FETCH_EXEMPTION[ERROR]: {
      return state.setIn(['pExemption', 'state'], fetchingState.ERROR);
    }
    case propertyActions.FETCH_AUTO_COMPLETE_LEGAL_START: {
      return state
        .setIn(['autoCompleteLegal', 'data'], fromJS({}))
        .setIn(['autoCompleteLegal', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_AUTO_COMPLETE_LEGAL_SUCCESS: {
      return state
        .setIn(['autoCompleteLegal', 'state'], fetchingState.LOADED)
        .setIn(
          ['autoCompleteLegal', 'data'],
          fromJS(_.get(action, 'data.results', {})),
        );
    }
    case propertyActions.FETCH_AUTO_COMPLETE_LEGAL_ERROR: {
      return state
        .setIn(['autoCompleteLegal', 'data'], fromJS({}))
        .setIn(['autoCompleteLegal', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_CREATE_EXEMPTION[START]: {
      return state.setIn(['pExemption', 'state'], fetchingState.SAVING);
    }
    case propertyActions.PROPERTY_CREATE_EXEMPTION[SUCCESS]: {
      return state
        .setIn(['pExemption', 'state'], fetchingState.LOADED)
        .setIn(
          ['pExemption', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case propertyActions.PROPERTY_CREATE_EXEMPTION[ERROR]: {
      return state.setIn(['pExemption', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_RESET_EXEMPTION: {
      return state.setIn(['pExemption', 'data'], fromJS({}));
    }
    case propertyActions.FETCH_EXEMPTION[SUCCESS]: {
      return state.setIn(
        ['pExemption', 'codeInfo'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );
    }

    case propertyActions.FETCH_ALL_DISTINCT_EXEMPTIONS[START]: {
      return state.setIn(['allExemptions', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_ALL_DISTINCT_EXEMPTIONS[SUCCESS]: {
      return state
        .setIn(['allExemptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['allExemptions', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_ALL_DISTINCT_EXEMPTIONS[ERROR]: {
      return state.setIn(['applicationOwners', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_CURRENT_APPLICATION_OWNERS[START]: {
      return state
        .setIn(['applicationOwners', 'state'], fetchingState.FETCHING)
        .setIn(['applicationOwners', 'data'], fromJS([]));
    }
    case propertyActions.FETCH_CURRENT_APPLICATION_OWNERS[SUCCESS]: {
      return state
        .setIn(['applicationOwners', 'state'], fetchingState.LOADED)
        .setIn(
          ['applicationOwners', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_CURRENT_APPLICATION_OWNERS[ERROR]: {
      return state.setIn(['applicationOwners', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_HS_DETAILS[START]: {
      return state.setIn(['hsDetails', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_HS_DETAILS[SUCCESS]: {
      return state
        .setIn(['hsDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['hsDetails', 'data'],
          fromJS(action.data ? action.data.results : {}),
        );
    }
    case propertyActions.FETCH_HS_DETAILS[ERROR]: {
      return state.setIn(['hsDetails', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_OWNER_NAMES[START]: {
      return state.setIn(['ownerNames', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_OWNER_NAMES[SUCCESS]: {
      return state
        .setIn(['ownerNames', 'state'], fetchingState.LOADED)
        .setIn(
          ['ownerNames', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.PROPERTY_FETCH_OWNER_NAMES[ERROR]: {
      return state.setIn(['ownerNames', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_TAXABLES[START]: {
      return state.setIn(['taxables', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_TAXABLES[SUCCESS]: {
      return state
        .setIn(['taxables', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxables', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['taxables', 'totalTaxes'],
          fromJS(action.data ? action.data.totalTaxes : ''),
        )
        .setIn(
          ['taxables', 'totalRate'],
          fromJS(action.data ? action.data.totalRate : ''),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXABLES[ERROR]: {
      return state.setIn(['taxableDetails', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_TAXABLE_DETAILS[START]: {
      return state.setIn(['taxableDetails', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_TAXABLE_DETAILS[SUCCESS]: {
      return state
        .setIn(['taxableDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxableDetails', 'data'],
          fromJS(action.data ? action.data.results : {}),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXABLE_DETAILS[ERROR]: {
      return state.setIn(['taxableDetails', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_SUMMARY_BPP[START]: {
      return state
        .setIn(['summaryBPP', 'data'], fromJS(null))
        .setIn(['summaryBPP', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_SUMMARY_BPP[SUCCESS]: {
      return state
        .setIn(['summaryBPP', 'state'], fetchingState.LOADED)
        .setIn(
          ['summaryBPP', 'data'],
          fromJS(action.data ? action.data.results[0] : null),
        );
    }
    case propertyActions.PROPERTY_FETCH_SUMMARY_BPP[ERROR]: {
      return state.setIn(['summaryBPP', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[
      START
    ]: {
      return state.setIn(
        ['taxingunitsplitboundarylines', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[
      SUCCESS
    ]:
    case propertyActions.TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE[SUCCESS]: {
      return state
        .setIn(['taxingunitsplitboundarylines', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingunitsplitboundarylines', 'data'],
          fromJS(action.data ? action.data.results[0] : {}),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[
      ERROR
    ]: {
      return state.setIn(
        ['taxingunitsplitboundarylines', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[START]: {
      return state
        .setIn(['taxingunitsegments', 'state'], fetchingState.FETCHING)
        .setIn(
          ['taxingunitsegments', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[SUCCESS]: {
      return state
        .setIn(['taxingunitsegments', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingunitsegments', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[ERROR]: {
      return state.setIn(['taxingunitsegments', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENT[START]: {
      return state
        .setIn(['taxingunitsegment', 'state'], fetchingState.FETCHING)
        .setIn(['taxingunitsegment', 'data'], fromJS([]));
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENT[SUCCESS]: {
      return state
        .setIn(['taxingunitsegment', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingunitsegment', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.PROPERTY_FETCH_TAXING_UNIT_SEGMENT[ERROR]: {
      return state.setIn(['taxingunitsegment', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_FETCH_SMART_GROUPS[START]:
      return state.setIn(
        ['propertySmartGroups', 'state'],
        fetchingState.FETCHING,
      );

    case propertyActions.PROPERTY_FETCH_SMART_GROUPS[SUCCESS]:
      newState = state.setIn(
        ['propertySmartGroups', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertySmartGroups', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_SMART_GROUPS[ERROR]:
      return state.setIn(['propertySmartGroups', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_SMART_GROUP[START]:
      return state
        .setIn(['smartGroup', 'state'], fetchingState.FETCHING)
        .setIn(['smartGroup', 'data'], fromJS(null));

    case propertyActions.PROPERTY_FETCH_SMART_GROUP[SUCCESS]:
      newState = state.setIn(['smartGroup', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['smartGroup', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_SMART_GROUP[ERROR]:
      return state.setIn(['smartGroup', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_SMART_GROUP_RESET:
      return state.setIn(['smartGroup', 'data'], null);

    case propertyActions.PROPERTY_FETCH_SMART_GROUP_PROPERTIES[START]:
      return state.setIn(
        ['smartGroupProperties', 'state'],
        fetchingState.FETCHING,
      );

    case propertyActions.PROPERTY_FETCH_SMART_GROUP_PROPERTIES[SUCCESS]:
      newState = state.setIn(
        ['smartGroupProperties', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['smartGroupProperties', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_SMART_GROUP_PROPERTIES[ERROR]:
      return state.setIn(
        ['smartGroupProperties', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_INSERT_SMART_GROUP_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_INSERT_SMART_GROUP_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_INSERT_SMART_GROUP_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_DELETE_SMART_GROUP_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_DELETE_SMART_GROUP_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_DELETE_SMART_GROUP_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_UPDATE_SMART_GROUP_FILE[START]: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_UPDATE_SMART_GROUP_FILE[SUCCESS]: {
      return state.setIn(['files', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_UPDATE_SMART_GROUP_FILE[ERROR]: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_SMART_GROUP_TYPES[START]:
      return state.setIn(['smartGroupTypes', 'state'], fetchingState.FETCHING);

    case propertyActions.PROPERTY_FETCH_SMART_GROUP_TYPES[SUCCESS]:
      newState = state.setIn(
        ['smartGroupTypes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['smartGroupTypes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_SMART_GROUP_TYPES[ERROR]:
      return state.setIn(['smartGroupTypes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[START]:
      return state.setIn(
        ['smartGroupsBySearch', 'state'],
        fetchingState.FETCHING,
      );

    case propertyActions.PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[SUCCESS]:
      newState = state.setIn(
        ['smartGroupsBySearch', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['smartGroupsBySearch', 'total'],
        fromJS(action.data ? action.data.totalSmartGroups.smartGroupCount : 0),
      );
      return newState.setIn(
        ['smartGroupsBySearch', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[ERROR]:
      return state.setIn(['smartGroupsBySearch', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_RESET_SMART_GROUPS_BY_SEARCH:
      return state.setIn(['smartGroupsBySearch', 'data'], fromJS([]));

    case propertyActions.PROPERTY_FETCH_INSPECTIONS[START]:
      return state.setIn(['inspections', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_INSPECTIONS[SUCCESS]:
      newState = state.setIn(['inspections', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['inspections', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_INSPECTIONS[ERROR]:
      return state.setIn(['inspections', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_DELETE_INSPECTION[SUCCESS]:
      return state.updateIn(['inspections', 'data'], (data) =>
        data.filter((e) => e.get('inspectionID') !== action.inspectionId),
      );
    case propertyActions.PROPERTY_INSPECTIONS_RESET:
      return state.setIn(['inspections', 'data'], fromJS([]));

    case propertyActions.PROPERTY_FETCH_REASON_CODES[START]:
      return state.setIn(['reasonCodes', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_REASON_CODES[SUCCESS]:
      newState = state.setIn(['reasonCodes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['reasonCodes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_REASON_CODES[ERROR]:
      return state.setIn(['reasonCodes', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_INSPECTION[START]:
      return state.setIn(['inspection', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_INSPECTION[SUCCESS]:
      newState = state.setIn(['inspection', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['inspection', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case propertyActions.PROPERTY_FETCH_INSPECTION[ERROR]:
      return state.setIn(['inspection', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_INSERT_INSPECTION_FILE[START]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_INSERT_INSPECTION_FILE[SUCCESS]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_INSERT_INSPECTION_FILE[ERROR]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_DELETE_INSPECTION_FILE[START]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_DELETE_INSPECTION_FILE[SUCCESS]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_DELETE_INSPECTION_FILE[ERROR]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_UPDATE_INSPECTION_FILE[START]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_UPDATE_INSPECTION_FILE[SUCCESS]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.PROPERTY_UPDATE_INSPECTION_FILE[ERROR]: {
      return state.setIn(['inspectionFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_FETCH_APPRAISERS[START]:
      return state.setIn(
        ['propertyAppraisers', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_APPRAISERS[SUCCESS]:
      newState = state.setIn(
        ['propertyAppraisers', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyAppraisers', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_APPRAISERS[ERROR]:
      return state.setIn(['propertyAppraisers', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_PRIMARY_APPRAISER[START]:
      return state.setIn(
        ['propertyPrimaryAppraiser', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_PRIMARY_APPRAISER[SUCCESS]:
      newState = state.setIn(
        ['propertyPrimaryAppraiser', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyPrimaryAppraiser', 'data'],
        fromJS(action.data ? action.data.results.appraiser : null),
      );
    case propertyActions.PROPERTY_FETCH_PRIMARY_APPRAISER[ERROR]:
      return state.setIn(
        ['propertyPrimaryAppraiser', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_PRIMARY_IMAGE_URL[START]:
      return state
        .setIn(['primaryImageUrl', 'state'], fetchingState.FETCHING)
        .setIn(['primaryImageUrl', 'data'], fromJS({}));
    case propertyActions.PROPERTY_FETCH_PRIMARY_IMAGE_URL[SUCCESS]:
      newState = state.setIn(
        ['primaryImageUrl', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['primaryImageUrl', 'data'],
        fromJS(action.data && action.data.results),
      );
    case propertyActions.PROPERTY_FETCH_PRIMARY_IMAGE_URL[ERROR]:
      return state.setIn(['primaryImageUrl', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_OBJECT_EVENTS[START]:
      return state
        .setIn(['objectEvents', 'state'], fetchingState.FETCHING)
        .setIn(['primaryImageUrl', 'data'], fromJS([]));
    case propertyActions.FETCH_OBJECT_EVENTS[SUCCESS]:
      newState = state.setIn(['objectEvents', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['objectEvents', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_OBJECT_EVENTS[ERROR]:
      return state.setIn(['objectEvents', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_PHOTOS_AND_DOCUMENTS[START]:
      return state
        .setIn(['objectEvents', 'state'], fetchingState.FETCHING)
        .setIn(['primaryImageUrl', 'data'], fromJS([]));
    case propertyActions.FETCH_PHOTOS_AND_DOCUMENTS[SUCCESS]:
      newState = state.setIn(['objectEvents', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['objectEvents', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_PHOTOS_AND_DOCUMENTS[ERROR]:
      return state.setIn(['objectEvents', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_AGENT_SUMMARY[START]:
      return state.setIn(['agentSummary', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_AGENT_SUMMARY[SUCCESS]:
      newState = state.setIn(['agentSummary', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['agentSummary', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.PROPERTY_FETCH_AGENT_SUMMARY[ERROR]:
      return state.setIn(['agentSummary', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMITS[START]:
      return state.setIn(['buildingPermits', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMITS[SUCCESS]:
      return state
        .setIn(
          ['buildingPermits', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['buildingPermits', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMITS[ERROR]:
      return state.setIn(['buildingPermits', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_RESET_BUILDING_PERMITS:
      return state.setIn(['buildingPermits', 'data'], fromJS([]));

    case propertyActions.PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[START]:
      return state.setIn(
        ['hsValueLimitations', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[SUCCESS]:
      return state
        .setIn(
          ['hsValueLimitations', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['hsValueLimitations', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[ERROR]:
      return state.setIn(['hsValueLimitations', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_HS_VALUE_LIMITATION[SUCCESS]:
      // console.log('reducer');
      // console.log(state.toJS());
      // console.log(action);
      // let result = updateStateArrayItem(
      //   state,
      //   action,
      //   'hsValueLimitations',
      //   'pAccountID',
      // );
      // console.log(result.toJS());
      // return result;
      let result = state.getIn(['hsValueLimitations', 'data']).toJS();
      if (action.data.results[0]) {
        for (let x = 0; x < result.length; x++) {
          if (result[x].ownerID === action.data.results[0].ownerID) {
            result[x] = action.data.results[0];
          }
        }
      }
      return state.setIn(['hsValueLimitations', 'data'], fromJS(result));

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[START]:
      return state.setIn(
        ['buildingPermitCodefiles', 'issuerCodes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'issuerCodes', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'issuerCodes', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[ERROR]:
      return state.setIn(
        ['buildingPermitCodefiles', 'issuerCodes', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_TYPES[START]:
      return state.setIn(
        ['buildingPermitCodefiles', 'types', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_TYPES[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'types', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'types', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_TYPES[ERROR]:
      return state.setIn(
        ['buildingPermitCodefiles', 'types', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[START]:
      return state.setIn(
        ['buildingPermitCodefiles', 'subTypes', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'subTypes', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'subTypes', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[ERROR]:
      return state.setIn(
        ['buildingPermitCodefiles', 'subTypes', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_STATUS[START]:
      return state.setIn(
        ['buildingPermitCodefiles', 'status', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_STATUS[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'status', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'status', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_STATUS[ERROR]:
      return state.setIn(
        ['buildingPermitCodefiles', 'status', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[START]:
      return state.setIn(
        ['buildingPermitCodefiles', 'CADStatus', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'CADStatus', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'CADStatus', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[ERROR]:
      return state.setIn(
        ['buildingPermitCodefiles', 'CADStatus', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[
      START
    ]:
      return state.setIn(
        ['buildingPermitCodefiles', 'propertyCategories', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[
      SUCCESS
    ]:
      return state
        .setIn(
          ['buildingPermitCodefiles', 'propertyCategories', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['buildingPermitCodefiles', 'propertyCategories', 'state'],
          fetchingState.LOADED,
        );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[
      ERROR
    ]:
      return state.setIn(
        ['buildingPermitCodefiles', 'propertyCategories', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT[START]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT[SUCCESS]:
      return state
        .setIn(['buildingPermit', 'data'], fromJS(action.data.results[0]))
        .setIn(['buildingPermit', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT[ERROR]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.ERROR);

    case propertyActions.RESET_BUILDING_PERMIT:
      return state.setIn(['buildingPermit', 'state'], fromJS(null));

    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT[START]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT[SUCCESS]:
      return state
        .setIn(['buildingPermit', 'data'], fromJS(action.data.results[0]))
        .setIn(['buildingPermit', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT[ERROR]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[START]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[SUCCESS]:
      return state
        .setIn(['buildingPermit', 'data'], fromJS(action.data.results[0]))
        .setIn(['buildingPermit', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[ERROR]:
      return state.setIn(['buildingPermit', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[START]:
      return state.setIn(
        ['buildingPermitProperties', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[SUCCESS]:
      return state
        .setIn(
          ['buildingPermitProperties', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['buildingPermitProperties', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[ERROR]:
      return state.setIn(
        ['buildingPermitProperties', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.INSERT_BUILDING_PERMIT_FILE[START]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.INSERT_BUILDING_PERMIT_FILE[SUCCESS]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case propertyActions.INSERT_BUILDING_PERMIT_FILE[ERROR]: {
      return state.setIn(['buildingPermitFiles', 'state'], fetchingState.ERROR);
    }

    case propertyActions.DELETE_BUILDING_PERMIT_FILE[START]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.DELETE_BUILDING_PERMIT_FILE[SUCCESS]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case propertyActions.DELETE_BUILDING_PERMIT_FILE[ERROR]: {
      return state.setIn(['buildingPermitFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.UPDATE_BUILDING_PERMIT_FILE[START]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.UPDATE_BUILDING_PERMIT_FILE[SUCCESS]: {
      return state.setIn(
        ['buildingPermitFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case propertyActions.UPDATE_BUILDING_PERMIT_FILE[ERROR]: {
      return state.setIn(['buildingPermitFiles', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_LAST_APPRAISAL[START]:
      return state.setIn(['lastAppraisal', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_LAST_APPRAISAL[SUCCESS]:
      return state
        .setIn(['lastAppraisal', 'data'], fromJS(action.data.results[0]))
        .setIn(['lastAppraisal', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_LAST_APPRAISAL[ERROR]:
      return state.setIn(['lastAppraisal', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_UPDATE_LAST_APPRAISAL[START]:
      return state.setIn(['lastAppraisal', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_UPDATE_LAST_APPRAISAL[SUCCESS]:
      return state
        .setIn(['lastAppraisal', 'data'], fromJS(action.data.results[0]))
        .setIn(['lastAppraisal', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_UPDATE_LAST_APPRAISAL[ERROR]:
      return state.setIn(['lastAppraisal', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[START]:
      return state.setIn(
        ['codeFilePropertyTags', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[SUCCESS]:
      return state
        .setIn(['codeFilePropertyTags', 'data'], fromJS(action.data.results))
        .setIn(['codeFilePropertyTags', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[ERROR]:
      return state.setIn(
        ['codeFilePropertyTags', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR[SUCCESS]:
      return state.setIn(
        ['codeFilePropertyTagsByYear', action.pYear],
        fromJS(action.data.results),
      );

    case propertyActions.PROPERTY_FETCH_PROPERTY_TAGS[START]:
      return state.setIn(['propertyTags', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_PROPERTY_TAGS[SUCCESS]:
      return state
        .setIn(['propertyTags', 'data'], fromJS(action.data.results))
        .setIn(['propertyTags', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_PROPERTY_TAGS[ERROR]:
      return state.setIn(['propertyTags', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_PROPERTY_LINKS[START]: {
      return state.setIn(['propertyLinks', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_PROPERTY_LINKS[SUCCESS]: {
      return state
        .setIn(['propertyLinks', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyLinks', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.FETCH_PROPERTY_LINKS[ERROR]: {
      return state.setIn(['propertyLinks', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_LINK_DELETE[SUCCESS]: {
      return state.setIn(
        ['propertyLinks', 'data'],
        fromJS(
          state
            .getIn(['propertyLinks', 'data'])
            .toJS()
            .filter((n) => n.linkID !== action.linkID),
        ),
      );
    }
    case propertyActions.PROPERTY_LINK_INSERT[SUCCESS]: {
      return state
        .setIn(['propertyLinks', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyLinks', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case propertyActions.PROPERTY_FETCH_RECALCULATION_JOB[START]: {
      return state.setIn(['recalculationJob', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_FETCH_RECALCULATION_JOB[SUCCESS]: {
      return state
        .setIn(['recalculationJob', 'state'], fetchingState.LOADED)
        .setIn(
          ['recalculationJob', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case propertyActions.PROPERTY_FETCH_RECALCULATION_JOB[ERROR]: {
      return state.setIn(['recalculationJob', 'state'], fetchingState.ERROR);
    }
    case propertyActions.PROPERTY_RESET_RECALCULATION_JOB: {
      return state.setIn(['recalculationJob', 'data'], fromJS({}));
    }
    case propertyActions.PROPERTY_SET_ACCOUNT_STATUS: {
      return state.setIn(['accountStatus', 'data'], fromJS(action.payload));
    }

    case propertyActions.PROPERTY_FETCH_ROLL_HISTORY[START]:
      return state.setIn(['rollHistory', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_ROLL_HISTORY[SUCCESS]:
      return state
        .setIn(['rollHistory', 'data'], fromJS(action.data.results))
        .setIn(['rollHistory', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_ROLL_HISTORY[ERROR]:
      return state.setIn(['rollHistory', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[START]:
      return state
        .setIn(['appraisalNoticeHistory', 'state'], fetchingState.FETCHING)
        .setIn(['appraisalNoticeHistory', 'data'], fromJS([]));
    case propertyActions.PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[SUCCESS]:
      return state
        .setIn(
          ['appraisalNoticeHistory', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(['appraisalNoticeHistory', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[ERROR]:
      return state.setIn(
        ['appraisalNoticeHistory', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.PROPERTY_FETCH_CURRENT_IMPROVEMENTS[START]:
      return state.setIn(
        ['currentImprovements', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.PROPERTY_FETCH_CURRENT_IMPROVEMENTS[SUCCESS]:
      return state
        .setIn(
          ['currentImprovements', 'data', 'ownerSitus'],
          fromJS(action.data.results.ownerSitus),
        )
        .setIn(
          ['currentImprovements', 'data', 'improvements'],
          fromJS(action.data.results.improvements),
        )
        .setIn(['currentImprovements', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_CURRENT_IMPROVEMENTS[ERROR]:
      return state
        .setIn(['currentImprovements', 'data', 'ownerSitus'], fromJS([]))
        .setIn(['currentImprovements', 'data', 'improvements'], fromJS([]))
        .setIn(['currentImprovements', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_RESET_CURRENT_IMPROVEMENTS:
      return state
        .setIn(['currentImprovements', 'data', 'ownerSitus'], fromJS([]))
        .setIn(['currentImprovements', 'data', 'improvements'], fromJS([]));

    case propertyActions.PROPERTY_FETCH_CURRENT_LANDS[START]:
      return state.setIn(['currentLands', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_CURRENT_LANDS[SUCCESS]:
      return state
        .setIn(
          ['currentLands', 'data', 'ownerSitus'],
          fromJS(action.data.results.ownerSitus),
        )
        .setIn(
          ['currentLands', 'data', 'lands'],
          fromJS(action.data.results.land),
        )
        .setIn(['currentLands', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_CURRENT_LANDS[ERROR]:
      return state
        .setIn(['currentLands', 'data', 'ownerSitus'], fromJS([]))
        .setIn(['currentLands', 'data', 'lands'], fromJS([]))
        .setIn(['currentLands', 'state'], fetchingState.ERROR);
    case propertyActions.PROPERTY_RESET_CURRENT_LANDS:
      return state
        .setIn(['currentLands', 'data', 'ownerSitus'], fromJS([]))
        .setIn(['currentLands', 'data', 'lands'], fromJS([]));

    case propertyActions.FETCH_OPEN_ROLL_CORRECTIONS[START]:
      newState = state.setIn(['openRollCorrections', 'data'], fromJS(null));
      return state.setIn(
        ['openRollCorrections', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_OPEN_ROLL_CORRECTIONS[SUCCESS]:
      newState = state.setIn(
        ['openRollCorrections', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['openRollCorrections', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_OPEN_ROLL_CORRECTIONS[ERROR]:
      return state.setIn(['openRollCorrections', 'state'], fetchingState.ERROR);

    case propertyActions.INSERT_ROLL_CORRECTION[SUCCESS]:
      return state.setIn(
        ['openRollCorrections', 'data'],
        fromJS([
          ...state.getIn(['openRollCorrections', 'data']).toJS(),
          ...(action.data ? action.data.results : []),
        ]),
      );

    case propertyActions.GET_PROPERTY_FILES[START]:
    case propertyActions.UPLOAD_PROPERTY_FILE[START]:
    case propertyActions.DELETE_PROPERTY_FILE[START]:
    case propertyActions.UPDATE_PROPERTY_FILE[START]: {
      return state.setIn(
        ['propertyRollCorrection', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.GET_PROPERTY_FILES[SUCCESS]:
    case propertyActions.DELETE_PROPERTY_FILE[SUCCESS]:
    case propertyActions.UPDATE_PROPERTY_FILE[SUCCESS]: {
      newState = state.setIn(
        ['propertyRollCorrection', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyRollCorrection', 'data'],
        fromJS(action.data ? action.data.results[0] : {}),
      );
    }

    case propertyActions.PROPERTY_FETCH_PLATS[START]:
      return state.setIn(['plats', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_FETCH_PLATS[SUCCESS]:
      return state
        .setIn(['plats', 'data'], fromJS(action.data.results))
        .setIn(['plats', 'state'], fetchingState.LOADED);
    case propertyActions.PROPERTY_FETCH_PLATS[ERROR]:
      return state.setIn(['plats', 'state'], fetchingState.ERROR);
    case propertyActions.RESET_PROPERTY_PLATS:
      return state.setIn(['plats', 'data'], fromJS([]));

    case propertyActions.FETCH_JAN_ONE_OWNER[START]: {
      return state.setIn(['janOneOwner', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_JAN_ONE_OWNER[SUCCESS]: {
      return state
        .setIn(['janOneOwner', 'state'], fetchingState.LOADED)
        .setIn(
          ['janOneOwner', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_JAN_ONE_OWNER[ERROR]: {
      return state.setIn(['janOneOwner', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_CALCULATION_RULES[START]:
      newState = state.setIn(['calculationRules', 'data'], fromJS([]));
      return newState.setIn(
        ['calculationRules', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_CALCULATION_RULES[SUCCESS]:
      newState = state.setIn(
        ['calculationRules', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['calculationRules', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_CALCULATION_RULES[ERROR]:
      return state.setIn(['calculationRules', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_ALLOCATION_FACTORS[START]:
      return state.setIn(
        ['allocationFactors', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_ALLOCATION_FACTORS[SUCCESS]:
      return state
        .setIn(['allocationFactors', 'state'], fetchingState.LOADED)
        .setIn(
          ['allocationFactors', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_ALLOCATION_FACTORS[ERROR]:
      return state.setIn(['allocationFactors', 'state'], fetchingState.ERROR);
    case propertyActions.RESET_ALLOCATION_FACTORS:
      return state
        .setIn(['allocationFactors', 'state'], null)
        .setIn(['allocationFactors', 'data'], fromJS([]));

    case propertyActions.FETCH_TAXING_UNIT_LOOKUP[START]:
      return state.setIn(['taxingUnitLookup', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_TAXING_UNIT_LOOKUP[SUCCESS]:
      return state
        .setIn(['taxingUnitLookup', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingUnitLookup', 'data'],
          fromJS(action.data ? action.data.results : {}),
        );
    case propertyActions.FETCH_TAXING_UNIT_LOOKUP[ERROR]:
      return state.setIn(['taxingUnitLookup', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_PROPERTY_FOR_SIT[START]:
      return state.setIn(['propertyForSit', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_PROPERTY_FOR_SIT[SUCCESS]:
      return state
        .setIn(['propertyForSit', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyForSit', 'data'],
          fromJS(action.data ? action.data.results[0] : {}),
        );
    case propertyActions.FETCH_PROPERTY_FOR_SIT[ERROR]:
      return state.setIn(['propertyForSit', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_SIT_DETAILS[START]:
      return state.setIn(['sitDetails', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_SIT_DETAILS[SUCCESS]:
      return state
        .setIn(['sitDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['sitDetails', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_SIT_DETAILS[ERROR]:
      return state.setIn(['sitDetails', 'state'], fetchingState.ERROR);
    case propertyActions.RESET_SIT_DETAILS:
      return state.setIn(['sitDetails', 'data'], fromJS([]));

    case propertyActions.FETCH_SIT[START]:
      return state.setIn(['sit', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_SIT[SUCCESS]:
      return state
        .setIn(['sit', 'state'], fetchingState.LOADED)
        .setIn(
          ['sit', 'data'],
          fromJS(
            action.data && action.data.results && action.data.results[0]
              ? action.data.results[0]
              : {},
          ),
        );
    case propertyActions.FETCH_SIT[ERROR]:
      return state.setIn(['sit', 'state'], fetchingState.ERROR);

    case propertyActions.UPDATE_SIT[SUCCESS]:
      return state.setIn(
        ['sit', 'data'],
        fromJS({
          ...state.getIn(['sit', 'data']).toJS(),
          ...(action.data && action.data.results && action.data.results[0]
            ? action.data.results[0]
            : {}),
        }),
      );

    case propertyActions.RESET_SIT:
      return state.setIn(['sit', 'data'], fromJS({}));

    case propertyActions.FETCH_SIT_DETAIL[START]:
      return state.setIn(['sitDetail', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_SIT_DETAIL[SUCCESS]:
      return state
        .setIn(['sitDetail', 'state'], fetchingState.LOADED)
        .setIn(
          ['sitDetail', 'data'],
          fromJS(
            action.data && action.data.results && action.data.results[0]
              ? action.data.results[0]
              : {},
          ),
        );
    case propertyActions.FETCH_SIT_DETAIL[ERROR]:
      return state.setIn(['sitDetail', 'state'], fetchingState.ERROR);
    case propertyActions.RESET_SIT_DETAIL:
      return state.setIn(['sitDetail', 'data'], fromJS({}));

    case propertyActions.INSERT_SIT_DETAIL_FILE[START]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.INSERT_SIT_DETAIL_FILE[SUCCESS]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.INSERT_SIT_DETAIL_FILE[ERROR]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.DELETE_SIT_DETAIL_FILE[START]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.DELETE_SIT_DETAIL_FILE[SUCCESS]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.DELETE_SIT_DETAIL_FILE[ERROR]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.UPDATE_SIT_DETAIL_FILE[START]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.UPDATE_SIT_DETAIL_FILE[SUCCESS]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.LOADED);
    }
    case propertyActions.UPDATE_SIT_DETAIL_FILE[ERROR]: {
      return state.setIn(['sitDetailFiles', 'state'], fetchingState.ERROR);
    }
    case propertyActions.FETCH_BPP_IMPORT[START]: {
      return state.setIn(['bppImport', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_BPP_IMPORT[SUCCESS]: {
      return state
        .setIn(['bppImport', 'state'], fetchingState.LOADED)
        .setIn(
          ['bppImport', 'data'],
          fromJS(R.pathOr({}, ['data', 'results', '0'], action)),
        );
    }
    case propertyActions.FETCH_BPP_IMPORT[ERROR]: {
      return state.setIn(['bppImportErrors', 'state'], fetchingState.ERROR);
    }
    case propertyActions.FETCH_BPP_IMPORT_ERRORS[START]: {
      return state.setIn(['bppImportErrors', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_BPP_IMPORT_ERRORS[SUCCESS]: {
      return state
        .setIn(['bppImportErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['bppImportErrors', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        );
    }
    case propertyActions.FETCH_BPP_IMPORT_ERRORS[ERROR]: {
      return state.setIn(['bppImportErrors', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_MARKET_APPROACH_VALUATION[START]: {
      return state.setIn(['marketApproach', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.REFRESH_MARKET_APPROACH[START]: {
      return state.setIn(['marketApproach', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.REFRESH_EQUITY_APPROACH[START]: {
      return state.setIn(['equityApproach', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.REFRESH_MARKET_APPROACH[SUCCESS]:
    case propertyActions.DELETE_MARKET_APPROACH_COMPS[SUCCESS]:
    case propertyActions.UPDATE_MARKET_APPROACH_AUTO_SELECT[SUCCESS]:
    case propertyActions.FETCH_MARKET_APPROACH_VALUATION[SUCCESS]: {
      let newState = JSON.parse(JSON.stringify(action));
      if (
        newState &&
        newState.data &&
        newState.data.results &&
        newState.data.results[0] &&
        newState.data.results[0].compGridData &&
        newState.data.results[0].compGridData.comparables &&
        newState.data.results[0].compGridData.comparables.length > 0
      ) {
        for (
          let x = 0;
          x < newState.data.results[0].compGridData.comparables.length;
          x++
        ) {
          newState.data.results[0].compGridData.comparables[x].sumDetailAdj =
            newState.data.results[0].compGridData.comparables[x][
              newState.data.results[0].displayFormat === 'Enhanced'
                ? 'highestValuedImprovementNonMADetails'
                : 'gridImprovementDetailData'
            ].reduce((total, r) => total + r.adjustmentDetail, 0);
          newState.data.results[0].compGridData.comparables[x].sumSegmentsAdj =
            newState.data.results[0].displayFormat === 'Enhanced'
              ? newState.data.results[0].compGridData.comparables[x][
                  'secondaryImprovementDetails'
                ].reduce((total, r) => total + r.adjustmentDetail, 0)
              : '';
        }
      }
      return state
        .setIn(['marketApproach', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketApproach', 'data'],
          fromJS(R.pathOr({}, ['data', 'results', '0'], newState)),
        );
    }
    case propertyActions.FETCH_MARKET_APPROACH_VALUATION[ERROR]: {
      return state.setIn(['marketApproach', 'state'], fetchingState.ERROR);
    }

    case propertyActions.UPDATE_MARKET_APPROACH_AUTO_SELECT[ERROR]:
      return state
        .setIn(['marketApproach', 'state'], fetchingState.ERROR)
        .setIn(['marketApproach', 'error'], fromJS(action.error));
    case propertyActions.FETCH_MARKET_APPROACH_COMP_IMAGES[START]: {
      return state.setIn(
        ['marketApproachCompImages', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_MARKET_APPROACH_COMP_IMAGES[SUCCESS]: {
      return state
        .setIn(['marketApproachCompImages', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketApproachCompImages', 'data'],
          fromJS(R.pathOr({}, ['data', 'results'], action)),
        );
    }
    case propertyActions.FETCH_MARKET_APPROACH_COMP_IMAGES[ERROR]: {
      return state.setIn(
        ['marketApproachCompImages', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.FETCH_EQUITY_APPROACH_VALUATION[START]: {
      return state.setIn(['equityApproach', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.REFRESH_EQUITY_APPROACH[SUCCESS]:
    case propertyActions.DELETE_EQUITY_APPROACH_COMPS[SUCCESS]:
    case propertyActions.UPDATE_EQUITY_APPROACH_AUTO_SELECT[SUCCESS]:
    case propertyActions.FETCH_EQUITY_APPROACH_VALUATION[SUCCESS]: {
      let newState = JSON.parse(JSON.stringify(action));
      if (
        newState &&
        newState.data &&
        newState.data.results &&
        newState.data.results[0] &&
        newState.data.results[0].compGridData &&
        newState.data.results[0].compGridData.comparables &&
        newState.data.results[0].compGridData.comparables.length > 0
      ) {
        for (
          let x = 0;
          x < newState.data.results[0].compGridData.comparables.length;
          x++
        ) {
          newState.data.results[0].compGridData.comparables[x].sumDetailAdj =
            newState.data.results[0].compGridData.comparables[x][
              newState.data.results[0].displayFormat === 'Enhanced'
                ? 'highestValuedImprovementNonMADetails'
                : 'gridImprovementDetailData'
            ].reduce((total, r) => total + r.adjustmentDetail, 0);
          newState.data.results[0].compGridData.comparables[x].sumSegmentsAdj =
            newState.data.results[0].displayFormat === 'Enhanced'
              ? newState.data.results[0].compGridData.comparables[x][
                  'secondaryImprovementDetails'
                ].reduce((total, r) => total + r.adjustmentDetail, 0)
              : '';
        }
      }
      return state
        .setIn(['equityApproach', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityApproach', 'data'],
          fromJS(R.pathOr({}, ['data', 'results', '0'], newState)),
        );
    }
    case propertyActions.FETCH_EQUITY_APPROACH_VALUATION[ERROR]: {
      return state.setIn(['equityApproach', 'state'], fetchingState.ERROR);
    }

    case propertyActions.UPDATE_EQUITY_APPROACH_AUTO_SELECT[ERROR]:
      return state
        .setIn(['equityApproach', 'state'], fetchingState.ERROR)
        .setIn(['equityApproach', 'error'], fromJS(action.error));

    case propertyActions.FETCH_EQUITY_APPROACH_COMP_IMAGES[START]: {
      return state.setIn(
        ['equityApproachCompImages', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_EQUITY_APPROACH_COMP_IMAGES[SUCCESS]: {
      return state
        .setIn(['equityApproachCompImages', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityApproachCompImages', 'data'],
          fromJS(R.pathOr({}, ['data', 'results'], action)),
        );
    }
    case propertyActions.FETCH_EQUITY_APPROACH_COMP_IMAGES[ERROR]: {
      return state.setIn(
        ['equityApproachCompImages', 'state'],
        fetchingState.ERROR,
      );
    }
    case propertyActions.FETCH_APPEALS[START]: {
      return state.setIn(['appeals', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_APPEALS[SUCCESS]: {
      return state
        .setIn(['appeals', 'state'], fetchingState.LOADED)
        .setIn(
          ['appeals', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_APPEALS[ERROR]: {
      return state.setIn(['appeals', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_MARKET_APPROACH_SUBJECT[START]: {
      return state.setIn(
        ['marketApproachSubject', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_MARKET_APPROACH_SUBJECT[SUCCESS]: {
      return state
        .setIn(['marketApproachSubject', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketApproachSubject', 'data'],
          fromJS(action.data ? action.data.results[0] : {}),
        );
    }
    case propertyActions.FETCH_MARKET_APPROACH_SUBJECT[ERROR]: {
      return state.setIn(
        ['marketApproachSubject', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.FETCH_EQUITY_APPROACH_SUBJECT[START]: {
      return state.setIn(
        ['equityApproachSubject', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_EQUITY_APPROACH_SUBJECT[SUCCESS]: {
      return state
        .setIn(['equityApproachSubject', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityApproachSubject', 'data'],
          fromJS(action.data ? action.data.results[0] : {}),
        );
    }
    case propertyActions.FETCH_EQUITY_APPROACH_SUBJECT[ERROR]: {
      return state.setIn(
        ['equityApproachSubject', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.FETCH_MARKET_TIERS[START]: {
      return state.setIn(
        ['marketApproachTiers', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_MARKET_TIERS[SUCCESS]: {
      return state
        .setIn(['marketApproachTiers', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketApproachTiers', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_MARKET_TIERS[ERROR]: {
      return state.setIn(['marketApproachTiers', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_EQUITY_TIERS[START]: {
      return state.setIn(
        ['equityApproachTiers', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.FETCH_EQUITY_TIERS[SUCCESS]: {
      return state
        .setIn(['equityApproachTiers', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityApproachTiers', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.FETCH_EQUITY_TIERS[ERROR]: {
      return state.setIn(['equityApproachTiers', 'state'], fetchingState.ERROR);
    }

    case propertyActions.MARKET_APPROACH_MANUAL_SELECTION[START]: {
      return state.setIn(
        ['marketApproachManualSelection', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.MARKET_APPROACH_MANUAL_RESET:
    case propertyActions.MARKET_APPROACH_MANUAL_SELECTION[SUCCESS]: {
      return state
        .setIn(['marketApproachManualSelection', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketApproachManualSelection', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.MARKET_APPROACH_MANUAL_SELECTION[ERROR]: {
      return state.setIn(
        ['marketApproachManualSelection', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.EQUITY_APPROACH_MANUAL_SELECTION[START]: {
      return state.setIn(
        ['equityApproachManualSelection', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.EQUITY_APPROACH_MANUAL_RESET:
    case propertyActions.EQUITY_APPROACH_MANUAL_SELECTION[SUCCESS]: {
      return state
        .setIn(['equityApproachManualSelection', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityApproachManualSelection', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case propertyActions.EQUITY_APPROACH_MANUAL_SELECTION[ERROR]: {
      return state.setIn(
        ['equityApproachManualSelection', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.FETCH_PROPERTY_EFILE[START]: {
      return state.setIn(['efile', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.GENERATE_PROPERTY_EFILE_PIN[SUCCESS]:
    case propertyActions.UPDATE_PROPERTY_EFILE[SUCCESS]:
    case propertyActions.FETCH_PROPERTY_EFILE[SUCCESS]: {
      return state
        .setIn(['efile', 'state'], fetchingState.LOADED)
        .setIn(
          ['efile', 'data'],
          fromJS(action.data ? action.data.results[0] : {}),
        );
    }
    case propertyActions.FETCH_PROPERTY_EFILE[ERROR]: {
      return state.setIn(['efile', 'state'], fetchingState.ERROR);
    }

    case propertyActions.SEARCH_PROPERTY_EQUITY[START]: {
      return state.setIn(['equityResults', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.SEARCH_PROPERTY_EQUITY[SUCCESS]: {
      return state
        .setIn(['equityResults', 'state'], fetchingState.LOADED)
        .setIn(
          ['equityResults', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.SEARCH_PROPERTY_EQUITY[ERROR]: {
      return state.setIn(['equityResults', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_PROPERTY_ERRORS[START]: {
      return state.setIn(['errors', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_PROPERTY_ERRORS[SUCCESS]: {
      return state
        .setIn(['errors', 'state'], fetchingState.LOADED)
        .setIn(['errors', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case propertyActions.FETCH_PROPERTY_ERRORS[ERROR]: {
      return state.setIn(['errors', 'state'], fetchingState.ERROR);
    }

    case propertyActions.SET_BACK_PROPERTY: {
      return state.set('backProperty', fromJS(action.data));
    }

    case propertyActions.SET_PROPERTY_EVENT_BACK_OPTION: {
      return state.set('propertyEventBackOption', fromJS(action.data));
    }

    case propertyActions.PROPERTY_UPDATE_INACTIVE_NOTE[SUCCESS]:
    case propertyActions.PROPERTY_UPDATE_REACTIVE_NOTE[SUCCESS]:
      const oldPropertyData = state.getIn(['property', 'data']).toJS();
      return state.setIn(
        ['property', 'data'],
        fromJS({ ...oldPropertyData, ...action.data.results[0] }),
      );

    case propertyActions.FETCH_GROUP_OPEN_ROLL_CORRECTIONS[START]:
      return state
        .setIn(['groupOpenRollCorrections', 'data'], fromJS([]))
        .setIn(['groupOpenRollCorrections', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_GROUP_OPEN_ROLL_CORRECTIONS[SUCCESS]:
      return state
        .setIn(['groupOpenRollCorrections', 'state'], fetchingState.LOADED)
        .setIn(
          ['groupOpenRollCorrections', 'data'],
          fromJS(action.data ? action.data.results : null),
        );
    case propertyActions.FETCH_GROUP_OPEN_ROLL_CORRECTIONS[ERROR]:
      return state.setIn(
        ['groupOpenRollCorrections', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.PROPERTY_SEARCH_PARAMS_FETCH[START]: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_SEARCH_PARAMS_FETCH[SUCCESS]: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.PROPERTY_SEARCH_PARAMS_FETCH[ERROR]: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_SEARCH_PARAM_FETCH[START]: {
      return state.setIn(['searchParam', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.PROPERTY_SEARCH_PARAM_FETCH[SUCCESS]:
    case propertyActions.PROPERTY_SEARCH_PARAM_INSERT[SUCCESS]:
    case propertyActions.PROPERTY_SEARCH_PARAM_UPDATE[SUCCESS]: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case propertyActions.PROPERTY_SEARCH_PARAM_FETCH[ERROR]: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }

    case propertyActions.PROPERTY_SET_SEARCH_FORM_DATA: {
      return state.setIn(['propertySearchFormData'], fromJS(action.payload));
    }

    case propertyActions.PROPERTY_SEARCH_PARAM_SET: {
      let cleanParam = state
        .getIn(['searchParams', 'data'])
        .toJS()
        .find((v) => v.searchParamID === action.searchParamID);
      cleanParam.searchParams = removeEmptyOptions(cleanParam.searchParams);
      return state.setIn(['searchParam', 'data'], fromJS(cleanParam));
    }

    case propertyActions.PROPERTY_FETCH_APPRAISAL_COMPANIES[START]: {
      return state.setIn(
        ['appraisalCompanies', 'state'],
        fetchingState.FETCHING,
      );
    }
    case propertyActions.PROPERTY_FETCH_APPRAISAL_COMPANIES[SUCCESS]: {
      return state
        .setIn(['appraisalCompanies', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalCompanies', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.PROPERTY_FETCH_APPRAISAL_COMPANIES[ERROR]: {
      return state.setIn(['appraisalCompanies', 'state'], fetchingState.ERROR);
    }

    case propertyActions.PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT[
      SUCCESS
    ]: {
      return state.setIn(
        ['appraisalCompanyLastImport'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );
    }

    case propertyActions.PROPERTY_FETCH_WORK_ITEMS[START]: {
      return state
        .setIn(['workItems', 'state'], fetchingState.FETCHING)
        .setIn(['workItems', 'data'], fromJS([]));
    }
    case propertyActions.PROPERTY_FETCH_WORK_ITEMS[SUCCESS]: {
      return state
        .setIn(['workItems', 'state'], fetchingState.LOADED)
        .setIn(
          ['workItems', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.PROPERTY_FETCH_WORK_ITEMS[ERROR]: {
      return state.setIn(['workItems', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_BPP_LATE_RENDITION_PENALTY[START]: {
      return state
        .setIn(['lateRenditionPenalty', 'state'], fetchingState.FETCHING)
        .setIn(['lateRenditionPenalty', 'data'], fromJS({}));
    }
    case propertyActions.FETCH_BPP_LATE_RENDITION_PENALTY[SUCCESS]:
    case propertyActions.UPDATE_BPP_LATE_RENDITION_PENALTY[SUCCESS]: {
      return state
        .setIn(['lateRenditionPenalty', 'state'], fetchingState.LOADED)
        .setIn(
          ['lateRenditionPenalty', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case propertyActions.FETCH_BPP_LATE_RENDITION_PENALTY[ERROR]: {
      return state.setIn(
        ['lateRenditionPenalty', 'state'],
        fetchingState.ERROR,
      );
    }

    case propertyActions.FETCH_PROPERTY_CASES[START]: {
      return state
        .setIn(['propertyCases', 'state'], fetchingState.FETCHING)
        .setIn(['propertyCases', 'data'], fromJS([]));
    }
    case propertyActions.FETCH_PROPERTY_CASES[SUCCESS]: {
      return state
        .setIn(['propertyCases', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyCases', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case propertyActions.FETCH_PROPERTY_CASES[ERROR]: {
      return state.setIn(['propertyCases', 'state'], fetchingState.ERROR);
    }

    case propertyActions.FETCH_BPP_SUB_DETAILS[START]:
      return state
        .setIn(['bppSubDetails', 'data'], fromJS([]))
        .setIn(['bppSubDetails', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_BPP_SUB_DETAILS[SUCCESS]:
      return state
        .setIn(['bppSubDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['bppSubDetails', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_BPP_SUB_DETAILS[ERROR]:
      return state.setIn(['bppSubDetails', 'state'], fetchingState.ERROR);

    case propertyActions.UPDATE_BPP_SUB_DETAIL[SUCCESS]:
      const subDetails = state.getIn(['bppSubDetails', 'data']).toJS();
      return state.setIn(
        ['bppSubDetails', 'data'],
        fromJS(
          subDetails.map((s) =>
            s.pSubDetailID === action.data.results[0].pSubDetailID
              ? action.data.results[0]
              : s,
          ),
        ),
      );

    case propertyActions.SET_SELECTED_PERSONAL_DETAIL_ID:
      return state.setIn(['selectedPersonalDetailID'], action.data);

    case propertyActions.SET_DASHBOARD_BREADCRUMB:
      return state.setIn(['dashboardBreadcrumb'], action.data);

    case propertyActions.PROPERTY_TIRZ_FETCH[SUCCESS]:
      return state.setIn(
        ['tirz'],
        fromJS(action.data ? action.data.results[0] : {}),
      );

    case propertyActions.PROPERTY_TIRZ_TAXING_UNITS_FETCH[START]:
      return state
        .setIn(['tirzTaxingUnits', 'data'], fromJS([]))
        .setIn(['tirzTaxingUnits', 'state'], fetchingState.FETCHING);
    case propertyActions.PROPERTY_TIRZ_TAXING_UNITS_FETCH[SUCCESS]:
      return state
        .setIn(['tirzTaxingUnits', 'state'], fetchingState.LOADED)
        .setIn(
          ['tirzTaxingUnits', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.PROPERTY_TIRZ_TAXING_UNITS_FETCH[ERROR]:
      return state.setIn(['tirzTaxingUnits', 'state'], fetchingState.ERROR);

    case propertyActions.PROPERTY_TIRZ_ADD[SUCCESS]:
      return state.setIn(
        ['property', 'data', 'tirzCd'],
        fromJS(action.data ? action.data.results[0].tirzCd : null),
      );

    case propertyActions.PROPERTY_TIRZ_REMOVE[SUCCESS]:
      return state.setIn(['property', 'data', 'tirzCd'], fromJS(null));

    case propertyActions.FETCH_PROPERTY_STATE_CODE_LISTING[START]: {
      return state
        .setIn(['ptdSummary', 'stateCodes', 'data'], fromJS([]))
        .setIn(['ptdSummary', 'stateCodes', 'state'], fetchingState.FETCHING)
        .setIn(['ptdSummary', 'ag', 'data'], fromJS([]))
        .setIn(['ptdSummary', 'ag', 'state'], fetchingState.FETCHING);
    }
    case propertyActions.FETCH_PROPERTY_STATE_CODE_LISTING[SUCCESS]: {
      console.log(action.data);
      return state
        .setIn(['ptdSummary', 'stateCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['ptdSummary', 'stateCodes', 'data'],
          fromJS(
            action.data
              ? action.data.results
                ? action.data.results.stateCodes
                : []
              : [],
          ),
        )
        .setIn(['ptdSummary', 'ag', 'state'], fetchingState.LOADED)
        .setIn(
          ['ptdSummary', 'ag', 'data'],
          fromJS(
            action.data
              ? action.data.results
                ? action.data.results.ag
                : []
              : [],
          ),
        );
    }
    case propertyActions.FETCH_PROPERTY_STATE_CODE_LISTING[ERROR]:
      return state
        .setIn(['ptdSummary', 'stateCodes', 'state'], fetchingState.ERROR)
        .setIn(['ptdSummary', 'ag', 'state'], fetchingState.ERROR);
    case propertyActions.FETCH_OPEN_ROLL_CORRECTION_GROUPS[START]:
      return state.setIn(
        ['openRollCorrectionGroups', 'state'],
        fetchingState.FETCHING,
      );
    case propertyActions.FETCH_OPEN_ROLL_CORRECTION_GROUPS[SUCCESS]:
      newState = state.setIn(
        ['openRollCorrectionGroups', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['openRollCorrectionGroups', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case propertyActions.FETCH_OPEN_ROLL_CORRECTION_GROUPS[ERROR]:
      return state.setIn(
        ['openRollCorrectionGroups', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_IMAGE_GALLERY_OPTIONS[START]:
      return state
        .setIn(['imageGalleryOptions', 'data'], fromJS([]))
        .setIn(['imageGalleryOptions', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_IMAGE_GALLERY_OPTIONS[SUCCESS]:
      return state
        .setIn(['imageGalleryOptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['imageGalleryOptions', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMAGE_GALLERY_OPTIONS[ERROR]:
      return state.setIn(['imageGalleryOptions', 'state'], fetchingState.ERROR);

    case propertyActions.FETCH_IMAGE_GALLERY_DATA[START]:
      return state
        .setIn(['imageGalleryData', 'data'], fromJS([]))
        .setIn(['imageGalleryData', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_IMAGE_GALLERY_DATA[SUCCESS]:
      return state
        .setIn(['imageGalleryData', 'state'], fetchingState.LOADED)
        .setIn(
          ['imageGalleryData', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMAGE_GALLERY_DATA[ERROR]:
      return state.setIn(['imageGalleryData', 'state'], fetchingState.ERROR);

    case propertyActions.HAS_FUTURE_VERSION[SUCCESS]:
      return state
        .setIn(
          ['futureVersion', 'hasFutureVersion'],
          action.data.results?.hasFutureVersion || false,
        )
        .setIn(['futureVersion', 'pID'], action.data.results?.pID || null)
        .setIn(
          ['futureVersion', 'pRollCorr'],
          action.data.results?.pRollCorr || null,
        )
        .setIn(
          ['futureVersion', 'pVersion'],
          action.data.results?.pVersion || null,
        )
        .setIn(['futureVersion', 'pYear'], action.data.results?.pYear || null);

    case propertyActions.CAN_CREATE_FUTURE_VERSION[SUCCESS]:
      return state
        .setIn(
          ['futureVersion', 'canCreateFutureVersion'],
          action.data.results?.canCreateFutureVersion || false,
        )
        .setIn(
          ['futureVersion', 'canCreateErrorReason'],
          action.data.results?.errorReason || '',
        );

    case propertyActions.FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[START]:
      return state
        .setIn(['publicPortalAssociatedUsers', 'data'], fromJS([]))
        .setIn(
          ['publicPortalAssociatedUsers', 'state'],
          fetchingState.FETCHING,
        );
    case propertyActions.FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[SUCCESS]:
      return state
        .setIn(['publicPortalAssociatedUsers', 'state'], fetchingState.LOADED)
        .setIn(
          ['publicPortalAssociatedUsers', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[ERROR]:
      return state.setIn(
        ['publicPortalAssociatedUsers', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_PROPERTY_ELECTRONIC_REQUESTS[START]:
      return state
        .setIn(['propertyElectronicRequests', 'data'], fromJS([]))
        .setIn(['propertyElectronicRequests', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_PROPERTY_ELECTRONIC_REQUESTS[SUCCESS]:
      return state
        .setIn(['propertyElectronicRequests', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyElectronicRequests', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_PROPERTY_ELECTRONIC_REQUESTS[ERROR]:
      return state.setIn(
        ['propertyElectronicRequests', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE[START]:
      return state
        .setIn(['propertyEfile', 'eFile', 'data'], fromJS({}))
        .setIn(['propertyEfile', 'eFile', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE[SUCCESS]:
      return state
        .setIn(['propertyEfile', 'eFile', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyEfile', 'eFile', 'data'],
          fromJS(
            action.data && action.data.results && action.data.results.length > 0
              ? action.data.results[0]
              : {},
          ),
        );
    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE[ERROR]:
      return state.setIn(
        ['propertyEfile', 'eFile', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_NOTICES_PROPERTY_PUBLIC_USERS[START]:
      return state
        .setIn(['propertyEfile', 'associatedUsers', 'data'], fromJS([]))
        .setIn(
          ['propertyEfile', 'associatedUsers', 'state'],
          fetchingState.FETCHING,
        );
    case propertyActions.FETCH_NOTICES_PROPERTY_PUBLIC_USERS[SUCCESS]:
      return state
        .setIn(
          ['propertyEfile', 'associatedUsers', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['propertyEfile', 'associatedUsers', 'data'],
          fromJS(action.data && action.data.results ? action.data.results : []),
        );
    case propertyActions.FETCH_NOTICES_PROPERTY_PUBLIC_USERS[ERROR]:
      return state.setIn(
        ['propertyEfile', 'associatedUsers', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE_HISTORY[START]:
      return state
        .setIn(['propertyEfile', 'eFileHistory', 'data'], fromJS([]))
        .setIn(
          ['propertyEfile', 'eFileHistory', 'state'],
          fetchingState.FETCHING,
        );
    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE_HISTORY[SUCCESS]:
      return state
        .setIn(['propertyEfile', 'eFileHistory', 'state'], fetchingState.LOADED)
        .setIn(
          ['propertyEfile', 'eFileHistory', 'data'],
          fromJS(action.data && action.data.results ? action.data.results : []),
        );
    case propertyActions.FETCH_NOTICES_PROPERTY_EFILE_HISTORY[ERROR]:
      return state.setIn(
        ['propertyEfile', 'eFileHistory', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.FETCH_TIMBER78_TAXING_UNITS[START]:
    case propertyActions.COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[START]:
      return state
        .setIn(['timber78Values', 'data'], fromJS([]))
        .setIn(['timber78Values', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_TIMBER78_TAXING_UNITS[SUCCESS]:
    case propertyActions.COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[SUCCESS]:
      return state
        .setIn(['timber78Values', 'state'], fetchingState.LOADED)
        .setIn(
          ['timber78Values', 'data'],
          fromJS(action.data && action.data.results ? action.data.results : []),
        );
    case propertyActions.COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[ERROR]:
    case propertyActions.FETCH_TIMBER78_TAXING_UNITS[ERROR]:
      return state.setIn(['timber78Values', 'state'], fetchingState.ERROR);
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[START]:
      return state
        .setIn(['impDetailManagerCharacteristics', 'data'], fromJS([]))
        .setIn(
          ['impDetailManagerCharacteristics', 'state'],
          fetchingState.FETCHING,
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[SUCCESS]:
      return state
        .setIn(
          ['impDetailManagerCharacteristics', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['impDetailManagerCharacteristics', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[ERROR]:
      return state.setIn(
        ['impDetailManagerCharacteristics', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CONDITIONS[START]:
      return state
        .setIn(['impDetailManagerConditions', 'data'], fromJS([]))
        .setIn(['impDetailManagerConditions', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CONDITIONS[SUCCESS]:
      return state
        .setIn(['impDetailManagerConditions', 'state'], fetchingState.LOADED)
        .setIn(
          ['impDetailManagerConditions', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_CONDITIONS[ERROR]:
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[START]:
      return state
        .setIn(['impDetailManagerNewValue', 'data'], fromJS([]))
        .setIn(['impDetailManagerNewValue', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[SUCCESS]:
      return state
        .setIn(['impDetailManagerNewValue', 'state'], fetchingState.LOADED)
        .setIn(
          ['impDetailManagerNewValue', 'data'],
          fromJS(action.data ? action.data.results[0] : []),
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[ERROR]:
      return state.setIn(
        ['impDetailManagerNewValue', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[START]:
      return state
        .setIn(['impDetailManagerPricingModel', 'data'], fromJS([]))
        .setIn(
          ['impDetailManagerPricingModel', 'state'],
          fetchingState.FETCHING,
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[SUCCESS]:
      return state
        .setIn(['impDetailManagerPricingModel', 'state'], fetchingState.LOADED)
        .setIn(
          ['impDetailManagerPricingModel', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[ERROR]:
      return state.setIn(
        ['impDetailManagerPricingModel', 'state'],
        fetchingState.ERROR,
      );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[START]:
      return state
        .setIn(['impDetailManagerAdjustment', 'data'], fromJS([]))
        .setIn(['impDetailManagerAdjustment', 'state'], fetchingState.FETCHING);
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[SUCCESS]:
      return state
        .setIn(['impDetailManagerAdjustment', 'state'], fetchingState.LOADED)
        .setIn(
          ['impDetailManagerAdjustment', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case propertyActions.FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[ERROR]:
      return state.setIn(
        ['impDetailManagerAdjustment', 'state'],
        fetchingState.ERROR,
      );

    case propertyActions.SET_PROPERTIES_MASS_UPDATE_MULTI_YEAR:
      return state.setIn(
        ['propertiesMassUpdateMultiYear'],
        fromJS(action.data),
      );
    case WORK_ITEMS_UPDATED:
      return state.set('workItemsUpdated', Date.now());
    default: {
      return state;
    }
  }
};
